<template>
  <div class="boothpage-lite-wrapper substitute-booth-page">
    <div class="container">
      <div class="mobile-booth-head-top">
        <div class="booth-head-left">
          <div class="back-to-hall">
            <router-link
              v-if="showAerialView == false && showBirdView == false"
              class="tab-link"
              v-on:click.prevent="clearRefresh"
              v-bind:to="{ name: 'Exhibitorshalllite' }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </router-link>
            <router-link
              v-else-if="showBirdView == true && showAerialView == false"
              class="tab-link"
              v-on:click.prevent="clearRefresh"
              v-bind:to="{ name: 'Exhibitorshalllite' }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </router-link>
            <router-link
              v-else
              class="tab-link"
              v-on:click.prevent="clearRefresh"
              v-bind:to="{ name: 'Exhibitorshalllite' }"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 434 434"
                  style="enable-background: new 0 0 434 434"
                  xml:space="preserve"
                  width="25px"
                  height="25px"
                  class
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M219.239,55.804c-18.137,0-32.84,14.703-32.84,32.84s14.703,32.84,32.84,32.84s32.84-14.703,32.84-32.84    C252.059,70.516,237.368,55.825,219.239,55.804z M219.239,101.484c-7.091,0-12.84-5.749-12.84-12.84    c0-7.091,5.749-12.84,12.84-12.84c7.091,0,12.84,5.749,12.84,12.84C232.071,95.732,226.327,101.476,219.239,101.484z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M423.919,358.219c-0.006,0-0.013,0-0.019,0H398v-200h17.842c5.522,0,10.158-4.042,10.158-9.564v-45.68    c-0.033-4.015-2.446-7.627-6.143-9.193L223.215,9.588c-2.52-1.077-5.372-1.077-7.892,0L18.892,93.782    c-3.639,1.595-5.963,5.221-5.892,9.193v45.68c-0.131,5.152,3.94,9.435,9.092,9.566c0.182,0.005,0.363,0.004,0.545-0.002H41v200    H10.1c-5.511-0.067-10.033,4.347-10.1,9.859c0,0.006,0,0.013,0,0.019v47.56c0,5.523,4.574,9.562,10.1,9.562h413.8    c5.523,0,10.1-4.039,10.1-9.562v-47.56C433.944,362.586,429.431,358.163,423.919,358.219z M33,138.219v-28.648l186.5-79.912    L406,109.571v28.648H33z M378,158.219v200h-49v-200H378z M309,158.219v200h-48v-200H309z M241,158.219v200h-48v-200H241z     M173,158.219v200h-48v-200H173z M105,158.219v200H61v-200H105z M414,405.219H20v-27h394V405.219z"
                          data-original="#000000"
                          class="active-path"
                          fill="#000000"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </router-link>
          </div>

          <h3 class="mb-0" id="boothHeaderTxt"></h3>
        </div>

        <div class="booth-mobile-slide-btn">
          <ul>
            <li>
              <a
                href="#"
                @click.prevent="LoadNext(prv)"
                :data-tag="'exibitorview/' + prv + '/LeftArrow'"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 455 455"
                    style="enable-background: new 0 0 455 455"
                    xml:space="preserve"
                    width="25px"
                    height="25px"
                  >
                    <g>
                      <path
                        d="M227.5,0C101.855,0,0,101.855,0,227.5S101.855,455,227.5,455S455,353.145,455,227.5S353.145,0,227.5,0z M276.772,334.411  l-21.248,21.178L127.852,227.5L255.524,99.411l21.248,21.178L170.209,227.5L276.772,334.411z"
                        data-original="#000000"
                        class="active-path"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                </span>
                <label>Prev</label>
              </a>
            </li>
            <li>
              <a
                @click.prevent="LoadNext(nxt)"
                :data-tag="'exibitorview/' + prv + '/RightArrow'"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 455 455"
                    style="enable-background: new 0 0 455 455"
                    xml:space="preserve"
                    width="25px"
                    height="25px"
                    class
                  >
                    <g>
                      <path
                        d="M227.5,0C101.855,0,0,101.855,0,227.5S101.855,455,227.5,455S455,353.145,455,227.5S353.145,0,227.5,0z M199.476,355.589  l-21.248-21.178L284.791,227.5L178.228,120.589l21.248-21.178L327.148,227.5L199.476,355.589z"
                        data-original="#000000"
                        class="active-path"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                </span>
                <label>Next</label>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-bind:id="item.id"
        v-bind:key="item.id"
        v-for="(item, index) in ExhibitorData"
      >
        <div class="lite-single-booth-wrap">
          <div class="booth-inner-lite wrap">
            <img :src="item.HotspotImageUrL" v-if="showVideoFlg == false" />
            <span v-html="item.HtmlCode" v-if="showVideoFlg == false"></span>

            <img
              @click="playVideoURL"
              v-if="item.ShowcaseVideoURL != '' && showVideoFlg == false"
              class="play-video-btn"
              src="../assets/Images/Play-expo-round-white.png"
            />

            <iframe
              id="frmVideo"
              v-if="showVideoFlg"
              :src="item.ShowcaseVideoURL"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              :data-tag="item.id + '/' + item.Name + ' -Video'"
            ></iframe>
            <v-btn
              v-if="showVideoFlg == true"
              @click="showVideoFlg = false"
              icon
              small
              text
              dark
              color="#333"
              class="button-back-to-booth"
              ><v-icon color="#333" size="20px">mdi-close</v-icon> Close
              Video</v-btn
            >
          </div>
        </div>
        <div class="booth-details-small">
          <div class="booth-image">
            <img :src="item.Logo" />
          </div>
          <div class="booth-description">
            <p>{{ item.Name }}</p>
          </div>
        </div>
        <div class="lite-booth-activity-section">
          <button
            :class="
              roundtableData.length == 0
                ? 'exchange-businesscard-lite mr-3 hide-roundtable'
                : 'exchange-businesscard-lite mr-3'
            "
            data-toggle="modal"
            data-target="#exampleModalCenter"
          >
            <span v-if="roundtableData.length > 0"
              >Exchange <br />
              Business Card</span
            >
            <span v-else>Exchange Business Card</span>
          </button>
          <span
            v-for="roundtable in roundtableData"
            v-bind:key="roundtable.id"
            v-show="roundtable.IsVisible"
          >
            <button
              style="visibility: hidden"
              id="dvMainRoundTable"
              :class="
                showBusinessCardBtn == false
                  ? 'join-round-table-lite hide-bussiness-card'
                  : 'join-round-table-lite'
              "
              :data-tag="'exibitorview/' + roundtable.hostId + '/Roundtable'"
              v-on:click="
                JoinTable(
                  roundtable.hostId,
                  GlobalKeysData.videoParamsEncryptURL,
                  GlobalKeysData.IsBroadcastInNewTab,
                  roundtable.id,
                  roundtable.Name,
                  '0',
                  roundtable.ChannelPrefix,
                  roundtable.BroadcastID,
                  roundtable.BroadcastCertificate,
                  roundtable.BroadcastSpeakerApiUrl,
                  roundtable.BroadcastAttendeeApiUrl,
                  roundtable.BroadcastvalidityHours,
                  roundtable.UserID,
                  eventId2,
                  roundtable.BroadcastStartURL,
                  roundtable.BroadcastViewURL,
                  roundtable.IsHost,
                  roundtable.IsMappedasAttendee,
                  roundtable.PreAssigned,
                  roundtable.SpectatorEnabled,
                  roundtable.Capacity,
                  roundtable.Occupied,
                  roundtable.IsVisible,
                  roundtable.IsTableFull,
                  GlobalKeysData.IsOpenInternalPlayer,
                  roundtable.StreamingClient,
                  roundtable.Zoom_Detail
                )
              "
            >
              <span v-if="showBusinessCardBtn == false"> Join Round Table</span>
              <span v-else
                >Join <br />
                Round Table</span
              >
            </button>
          </span>
        </div>
        <div class="booth-inner-company-details-lite">
          <ul class="nav nav-tabs expo-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="home-tab"
                data-toggle="tab"
                href="#home"
                role="tab"
                aria-controls="home"
                aria-selected="true"
                >Profile</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="profile-tab"
                data-toggle="tab"
                href="#profile"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
                >Contacts</a
              >
            </li>

            <li class="nav-item" v-if="isPodiumEnabled">
              <a
                class="nav-link"
                id="upcomingEvent-tab"
                data-toggle="tab"
                href="#upcomingevent"
                role="tab"
                aria-controls="upcomingevent-tab"
                aria-selected="false"
                >Upcoming Events</a
              >
            </li>

            <li class="nav-item" v-if="ExhibitorFiles.length > 0">
              <a
                class="nav-link"
                id="contact-tab"
                data-toggle="tab"
                href="#contact"
                role="tab"
                aria-controls="contact"
                aria-selected="false"
                >Collaterals</a
              >
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div class="mobile-company-profile">
                <p v-html="item.Profile"></p>
                <ul>
                  <li>
                    <a
                      :href="'mailto:' + item.Email"
                      target="_blank"
                      v-if="item.Email !== ''"
                      :data-tag="'Email -' + item.Name + '-' + item.Email"
                      >{{ item.Email }}</a
                    >
                  </li>
                  <li>
                    <a
                      :href="'tel:' + item.Phone"
                      :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                      v-if="item.Phone !== ''"
                      >{{ item.Phone }}</a
                    >
                  </li>
                  <li>
                    <a
                      target="_blank"
                      :href="item.Website"
                      :data-tag="'Website -' + item.Name + '-' + item.Website"
                      v-if="item.Website !== ''"
                      >{{ item.Website }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div class="mobile-contacts-wrap">
                <div
                  class="mobile-single-contact"
                  v-bind:id="item1.id"
                  v-bind:key="item1.id"
                  v-for="item1 in item.MappedContacts"
                >
                  <div
                    class="mobile-cont-dect-wrap"
                    :data-tag="item.id + '/' + item.Name + '  Contact'"
                  >
                    <div class="mobile-contact-image-wrapper active-contact">
                      <div class="contact-image">
                        <img :src="item1.ProfilePictureURL" />
                      </div>
                    </div>
                    <div class="mobile-cont-desc">
                      <h4>{{ item1.FirstName }} {{ item1.LastName }}</h4>
                      <p>{{ item1.Designation }}</p>
                      <p>{{ item1.Company }}</p>
                    </div>
                  </div>
                  <div class="mobile-contact-options">
                    <ul>
                      <li
                        v-if="item1.VideoCallEnable"
                        :data-tag="'VideoCall-' + item1.Name + '-' + item.Name"
                      >
                        <a
                          :id="'lnkVideoCall' + item1.AttendeeId"
                          href="#"
                          :data-tag="
                            'VideoCall-' + item1.Name + '-' + item.Name
                          "
                          @click="onClickHandler"
                          v-on:click.prevent="
                            StartBroadcast(
                              GlobalKeysData.BroadcastStartURL,
                              GlobalKeysData.videoParamsEncryptURL,
                              GlobalKeysData.IsBroadcastInNewTab,
                              item.id,
                              item.Name,
                              item1.Name,
                              item1.AttendeeId,
                              GlobalKeysData.broadcastbaseURL,
                              GlobalKeysData.BroadcastStartURL,
                              GlobalKeysData.BroadcastvalidityHours,
                              GlobalKeysData.videoId,
                              GlobalKeysData.BroadcastCertificate,
                              GlobalKeysData.BroadcastID,
                              GlobalKeysData.ChannelPrefix,
                              GlobalKeysData.BroadcastSpeakerApiUrl,
                              GlobalKeysData.BroadcastAttendeeApiUrl,
                              GlobalKeysData.IsOpenInternalPlayer,
                              item1.StreamingClient,
                              item1.Zoom_Detail
                            );
                            return false;
                          "
                          class="openBroadcast"
                          title="Video call"
                        >
                          <img
                            data-toggle="tooltip"
                            data-html="true"
                            title
                            data-original-title="Video Chat"
                            :data-tag="
                              'VideoCall-' + item1.Name + '-' + item.Name
                            "
                            src="../assets/Images/icons/video3.svg"
                        /></a>
                      </li>
                      <li
                        v-else
                        :data-tag="'VideoCall-' + item1.Name + '-' + item.Name"
                      >
                        <img
                          src="../assets/Images/video-call-grey.svg"
                          data-toggle="tooltip"
                          data-html="true"
                          :data-tag="
                            'VideoCall-' + item1.Name + '-' + item.Name
                          "
                          title
                          data-original-title="Video Chat"
                        />
                      </li>
                      <li :data-tag="'Email-' + item1.Name + '-' + item.Name">
                        <a
                          v-on:click="onClickHandler"
                          :href="'mailto:' + item1.Email"
                          target="_blank"
                          title="Email"
                          :data-tag="'Email-' + item1.Name + '-' + item.Name"
                          ><img
                            src="../assets/Images/icons/envelope2.svg"
                            data-toggle="tooltip1"
                            data-html="true"
                            :data-tag="'Email-' + item1.Name + '-' + item.Name"
                            title
                            data-original-title="Email"
                        /></a>
                      </li>
                      <li
                        :data-tag="'Meeting-' + item1.Name + '-' + item.Name"
                        data-toggle="modal"
                        v-bind:data-target="'#calendarModal' + index"
                        v-on:click="OpenRequestMeeting(item1)"
                      >
                        <input type="hidden" id="hdnAttendeeId" />
                        <a
                          data-toggle="tooltip"
                          data-placement="top"
                          @click="onClickHandler"
                          :data-tag="'Meeting-' + item1.Name + '-' + item.Name"
                          data-original-title="Request Meeting"
                          title="1:1 Meeting"
                          ><img
                            src="../assets/Images/Meeting.svg"
                            :data-tag="
                              'Meeting-' + item1.Name + '-' + item.Name
                            "
                        /></a>
                      </li>
                      <li
                        v-if="userid != item1.AttendeeId"
                        v-on:click="OpenOneToOneChat(item1)"
                        :data-tag="
                          'One To One Chat-' + item1.Name + '-' + item.Name
                        "
                      >
                        <a
                          data-toggle="tooltip"
                          data-placement="top"
                          class="ml-2"
                          :data-tag="
                            'One To One Chat-' + item1.Name + '-' + item.Name
                          "
                          data-original-title="Request Chat"
                          title="1:1 Chat"
                          ><img
                            src="../assets/Images/icons/chat.svg"
                            :data-tag="
                              'One To One Chat-' + item1.Name + '-' + item.Name
                            "
                        /></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="upcomingevent"
              role="tabpanel"
              aria-labelledby="upcomingevent-tab"
            >
              <div class="mobile-podium-hld text-center pt-3">
                <h4 v-if="podiumTitle">{{ podiumTitle }}</h4>
                <p class="text-justify" v-if="podiumDescription">
                  {{ podiumDescription }}
                </p>
                <div
                  class="empodium-bottom-buttons d-flex justify-content-center"
                >
                  <a
                    class="single-bottom-buttons mr-2"
                    :href="knowMoreLink"
                    target="_blank"
                    v-if="knowMoreLink"
                    >KNOW MORE
                    <v-icon color="#ffffff" size="25px"
                      >mdi-arrow-right</v-icon
                    ></a
                  >
                  <v-btn
                    class="single-bottom-buttons"
                    :loading="registering"
                    @click="
                      Register(
                        ExhibitorData[0].id,
                        ExhibitorData[0].Name,
                        podiumTitle
                      )
                    "
                  >
                    REGISTER
                    <v-icon color="#ffffff" size="25px"
                      >mdi-arrow-right</v-icon
                    ></v-btn
                  >
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="contact"
              role="tabpanel"
              aria-labelledby="contact-tab"
            >
              <div class="mobile-collaterals-wrapper">
                <div
                  class="mobile-single-collaterals"
                  v-bind:id="item2.id"
                  v-bind:key="item2.id"
                  v-for="item2 in ExhibitorFiles"
                >
                  <div
                    class="collateral-file-icon-img"
                    :data-tag="
                      'Download - ' + item.Name + ' - ' + item2.Filename
                    "
                  >
                    <img
                      v-if="item2.Url.includes('.mp4')"
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                      src="../assets/Images/icons/video-icon.svg"
                      style="height: 35px; width: 35px"
                    />
                    <img
                      v-else
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                      src="../assets/Images/icons/pdf.svg"
                    />
                  </div>
                  <div class="collaterals-file">
                    <a
                      :href="item2.Url"
                      target="_blank"
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                    >
                      <h4>{{ item2.Filename }}</h4>
                    </a>
                  </div>
                  <div class="collaterals-download">
                    <a
                      :href="item2.Url"
                      target="_blank"
                      :data-tag="
                        'Download - ' + item.Name + ' - ' + item2.Filename
                      "
                    >
                      <!-- <img src="../assets/Images/icons/download.svg" /> -->
                      <i
                        class="fa fa-external-link"
                        aria-hidden="true"
                        style="color: black"
                      ></i>
                    </a>
                  </div>
                </div>
                <div
                  class="mobile-single-collaterals"
                  v-bind:id="links.id"
                  v-bind:key="links.id"
                  v-for="links in ExhibitorLinks"
                >
                  <div
                    class="collateral-file-icon-img"
                    :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                  >
                    <img
                      :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                      src="../assets/Images/icons/link.svg"
                      style="height: 35px; width: 35px"
                    />
                  </div>
                  <div class="collaterals-file">
                    <a
                      :href="links.Link"
                      target="_blank"
                      :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                    >
                      <h4>{{ links.Title }}</h4>
                    </a>
                  </div>
                  <div class="collaterals-download">
                    <a
                      :href="links.Link"
                      target="_blank"
                      :data-tag="'Link - ' + links.Title + ' - ' + links.Link"
                    >
                      <!-- <img src="../assets/Images/icons/download.svg" /> -->
                      <i
                        class="fa fa-external-link"
                        aria-hidden="true"
                        style="color: black"
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RequestMeeting></RequestMeeting>
    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        class="business-card-modal modal-dialog modal-dialog-centered"
        role="document"
        id="businessCrdModal"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Leave a Message
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <textarea
              placeholder="Your Message"
              id="sendBunessCardMsg"
            ></textarea>
          </div>
          <div class="modal-footer">
            <div class="mobile-card-exchange-footer">
              <p>You agree to exchange contact details with this Expo booth</p>
              <button
                type="button"
                class="btn btn-primary"
                :data-tag="'Exchange Bussiness Card -  Exhibitor -' + BoothName"
                v-on:click="ExchangeBusinessCard"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="game-wrap">
      <h3>Participate Scavenger Hunt</h3>
      <v-dialog transition="dialog-bottom-transition" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <div class="code-reveal-btn" v-bind="attrs" v-on="on">
            <img src="../assets/Images/leaderboard/reveal-code.svg" />
            <p>
              Reveal Code

              <v-icon dark color="#f62290" size="25">mdi-arrow-right</v-icon>
            </p>
          </div>
        </template>

        <template v-slot:default="dialog" class="shadow-hide">
          <div class="mobile-scavenger-dialog">
            <div class="mobile-scavenger-dialog-inner">
              <div class="mobile-congo">
                <img src="../assets/Images/leaderboard/congratulations.png" />
              </div>
              <p>You have revealed the secret code</p>
              <div class="mobile-reveal-code">
                <h4>SBC20</h4>
              </div>
              <p>You have received</p>
              <h3>10</h3>
              <p style="font-size: 20px" class="my-0">Points</p>
              <v-btn
                depressed
                color="#fff"
                class="mt-4"
                @click="dialog.value = false"
              >
                Collect Now
              </v-btn>
            </div>
          </div>
        </template>
      </v-dialog>
    </div>

    <v-dialog v-model="eventRegSuccessDialog" width="500">
      <v-card>
        <v-card-text>
          <div class="success-event-hld position-rleative">
            <v-btn
              icon
              class="close-btn-success"
              @click="eventRegSuccessDialog = false"
              ><v-icon color="#333" size="24px">mdi-close</v-icon></v-btn
            >
            <img src="../assets/Images/landing/recorded.svg" />
            <p>
              Your interest for the event is successfully recorded. You will
              hear from the Organizer soon.
            </p>
            <v-btn
              dark
              class="yes-submit"
              width="120px"
              @click="eventRegSuccessDialog = false"
              >OK</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style lang="scss">
.substitute-booth-page {
  .booth-mobile-slide-btn ul li a {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 10px !important;
  }
  .booth-mobile-slide-btn ul li:last-child a {
    margin-right: 0;
  }
  .booth-mobile-slide-btn ul li a label {
    margin: 0;
    color: #000;
  }
  .mobile-card-exchange-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  .mobile-card-exchange-footer p {
    margin: 0;
  }
  .boothpage-lite-wrapper {
    background: #eee;
    padding: 20px 0;
    height: 100%;
  }
  .lite-single-booth-wrap {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .booth-details-small {
    background: #333;
    padding: 15px;
    margin: 20px 0;
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .booth-details-small .booth-image {
    height: 148px;
    background: #fff;
    width: 200px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .booth-details-small .booth-image img {
    width: 100%;
  }
  .booth-details-small .booth-description {
    padding-left: 18px;
  }
  .booth-details-small .booth-description p {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
  }
  .exchange-businesscard-lite {
    background: #19a883 url(../assets/Images/exchange-business-card.svg)
      no-repeat 7% 35%;
    height: 52px;
    width: 282px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 2px solid #fff;
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    padding-left: 44px;
    cursor: pointer;
  }
  .join-round-table-lite {
    background: #1a5493 url(../assets/Images/round-table-white.svg) no-repeat 7%
      35%;
    height: 52px;
    width: 200px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 2px solid #fff;
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    padding-left: 44px;
    cursor: pointer;
  }
  .booth-inner-company-details-lite {
    margin-top: 25px;
  }
  .booth-inner-company-details-lite .nav-tabs {
    border-bottom: none;
  }
  .booth-inner-company-details-lite .nav-tabs .nav-link {
    border: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom: 4px solid transparent;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .booth-inner-company-details-lite .nav-tabs .nav-link.active,
  .booth-inner-company-details-lite .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: transparent;
    border-color: #f00;
    color: #000;
    font-weight: 600;
  }
  .booth-inner-company-details-lite ul li a {
    color: #333;
  }
  .mobile-company-profile {
    padding: 15px 0;
  }
  .mobile-company-profile p {
    color: #333;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin: 0;
  }
  .mobile-company-profile ul {
    margin: 15px 0 0;
    padding: 0;
  }
  .mobile-company-profile ul li {
    list-style: none;
    display: block;
  }
  .mobile-company-profile ul li a {
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    padding-left: 40px;
    margin-bottom: 8px;
  }
  .mobile-company-profile ul li:first-child a {
    background: url(../assets/Images/icons/envelope.svg) no-repeat scroll left
      center;
  }
  .mobile-company-profile ul li:nth-child(2) a {
    background: url(../assets/Images/icons/contact.svg) no-repeat scroll left
      center;
  }
  .mobile-company-profile ul li:last-child a {
    background: url(../assets/Images/icons/web.svg) no-repeat scroll left center;
  }
  .mobile-contacts-wrap {
    padding: 15px;
  }
  .mobile-contact-image-wrapper {
    height: 53px;
    width: 53px;
    border-radius: 50%;
    position: relative;
  }
  .mobile-contact-image-wrapper.active-contact:after {
    content: "";
    position: absolute;
    height: 10px;
    width: 10px;
    background: #2ec72e;
    right: 8px;
    bottom: 3px;
    border-radius: 50%;
  }
  .mobile-contact-image-wrapper.away-contact:after {
    content: "";
    position: absolute;
    height: 10px;
    width: 10px;
    background: #ffc400;
    right: 8px;
    bottom: 3px;
    border-radius: 50%;
  }
  .mobile-contact-image-wrapper.offline-contact:after {
    content: "";
    position: absolute;
    height: 10px;
    width: 10px;
    background: #f00;
    right: 8px;
    bottom: 3px;
    border-radius: 50%;
  }
  .mobile-cont-dect-wrap .contact-image {
    height: 50px;
    width: 50px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: relative;
    background: #f2f2f2;
  }
  .mobile-cont-dect-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .mobile-cont-desc {
    padding-left: 15px;
  }
  .mobile-cont-desc h4 {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-bottom: 3px;
  }
  .mobile-cont-desc p {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    margin-bottom: 3px;
  }
  .mobile-single-contact {
    padding: 15px;
    box-shadow: 0 0 6px rgb(0 0 0 / 50%);
    border-radius: 5px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 15px;
    flex-direction: column;
  }
  .mobile-contact-options ul {
    margin: 0;
    padding: 0;
  }
  .mobile-contact-options ul li {
    list-style: none;
    display: inline-block;
  }
  .mobile-contact-options ul li a {
    display: inline-block;
    margin: 10px;
  }
  .mobile-contacts-wrap {
    padding: 15px;
    height: 287px;
    overflow-y: auto;
  }
  .mobile-collaterals-wrapper {
    padding: 15px;
    height: 250px;
    overflow-y: auto;
  }
  .mobile-single-collaterals {
    padding: 8px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  .collaterals-file h4 {
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin: 0;
    padding-left: 10px;
    /* background: url(../assets/Images/icons/pdf.svg) no-repeat left center / auto; */
    line-height: 17px;
    word-break: break-word;
  }
}
.substitute-booth-page .booth-inner-company-details-lite .nav-tabs {
  padding: 0 !important;
}
.single-bottom-buttons {
  display: inline-flex;
  background-image: linear-gradient(88deg, #2c98cb, #2fb985) !important;
  width: 150px;
  margin: 3px 0;
  height: 44px;
  font-size: 1.1rem;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "Poppins", sans-serif;
  color: #fff !important;
}
button.button-back-to-booth {
  position: absolute;
  bottom: -6px;
  right: 50%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .substitute-booth-page {
    button.exchange-businesscard-lite.hide-roundtable {
      justify-content: flex-start;
    }
    button.join-round-table-lite.hide-bussiness-card {
      justify-content: flex-start;
    }
    .expo-tabs {
      display: flex;
      justify-content: center;
    }
    .exchange-businesscard-lite {
      width: 50%;
      font-size: 14px;
      background-size: 27px;
      padding-left: 37px;
    }
    .join-round-table-lite {
      width: 45%;
      font-size: 14px;
    }
    .join-round-table-lite {
      padding-left: 30px;
      background-size: 24px;
    }
    .mobile-single-contact {
      padding: 8px;
    }
    .mobile-contact-options ul li a img {
      height: 30px;
      width: 30px;
    }

    .mobile-contact-options {
      width: 100%;
    }

    .mobile-contact-options ul {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .mobile-cont-desc {
      padding-left: 0px;
    }
    .mobile-cont-desc h4 {
      font-size: 16px;
      margin-bottom: 0;
    }
    .mobile-cont-desc p {
      font-size: 14px;
      margin-bottom: 0;
    }
    .mobile-contact-options ul li a {
      margin: 10px;
    }
    .mobile-contacts-wrap {
      padding: 15px 8px;
    }
    .mobile-cont-dect-wrap .contact-image {
      height: 40px;
      width: 40px;
    }
    .mobile-contact-image-wrapper {
      height: 40px;
      width: 48px;
    }
    .collaterals-file h4 {
      font-size: 16px;
    }
    .play-video-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .booth-inner-lite {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-bottom: 24px;
    }
    .booth-inner-light img {
      max-width: 100%;
      height: 100%;
    }
    .booth-inner-light img.play-video-btn {
      height: auto !important;
    }
    .business-card-modal .modal-body textarea {
      width: 100%;
      height: 200px;
      border-radius: 6px;
      border: 1px solid #dfdfdf;
      padding: 10px;
      font-size: 14px;
      color: #838383;
      resize: none;
    }
    .business-card-modal .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0rem 1rem;
      border-bottom: none;
    }
    .business-card-modal button.close {
      position: relative;
      top: 0;
      right: 0;
      z-index: 99;
    }
    .business-card-modal .btn-primary {
      color: #fff;
      background-color: #19a883;
      border-color: #19a883;
    }
    .collaterals-download {
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 0 0 30px;
    }
    .collaterals-download img {
      max-width: 100%;
      height: 100%;
    }
    .collateral-file-icon-img img {
      max-width: 100%;
      height: 100%;
    }
    .collateral-file-icon-img {
      width: 30px;
      height: 30px;
      flex: 30px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .booth-inner-lite iframe {
      width: 100%;
      height: 354px;
    }
    .booth-details-small .booth-image {
      height: 100px;
      width: 30%;
      flex: 30% 0 0;
    }
    .mobile-booth-head-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
    .booth-head-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .back-to-hall {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin-right: 10px;
    }
    .back-to-hall img {
      max-width: 100%;
      height: 100%;
    }
    .booth-mobile-slide-btn ul {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .booth-mobile-slide-btn ul li {
      display: inline-block;
    }
    .booth-mobile-slide-btn ul li:last-child {
      margin-right: 0;
    }

    .booth-mobile-slide-btn ul li span {
      display: inline-flex;
      height: 25px;
      width: 25px;
      justify-content: center;
      align-items: center;
    }
    .boothpage-lite-wrapper {
      padding: 20px 0 20px 80px;
    }

    .game-wrap {
      position: fixed;
      bottom: 0;
      z-index: 99;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801; /* Old browsers */
      background: -moz-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff6801', endColorstr='#f62290',GradientType=1 ); /* IE6-9 */
      width: 100%;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      h3 {
        margin: 0;
        color: #fff;
        font-weight: 600;
        font-size: 24px;
        padding-left: 10px;
      }
    }
    .v-dialog {
      box-shadow: none !important;
    }
    .code-reveal-btn {
      background: #fff;
      margin-right: 10px;
      padding: 8px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      width: 212px;
      p {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0;
        color: #f62290;
        font-weight: 600;
      }
    }
    .mobile-scavenger-dialog {
      height: 390px;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801; /* Old browsers */
      background: -moz-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to bottom,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff6801', endColorstr='#f62290',GradientType=0 ); /* IE6-9 */
      border-radius: 25px;

      .mobile-scavenger-dialog-inner {
        height: 100%;
        padding: 22px;
        text-align: center;

        p {
          color: #fff;
          margin-top: 17px;
          width: 150px;
          margin: 12px auto 0;
          font-size: 18px;
        }
        .mobile-reveal-code h4 {
          display: inline-block;
          background: #fff;
          padding: 5px 8px;
          border-radius: 10px;
          margin-top: 10px;
        }
        h3 {
          color: #fff;
          font-size: 50px;
          margin: 0;
          line-height: 46px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .substitute-booth-page {
    button.exchange-businesscard-lite.hide-roundtable {
      width: 100%;
      justify-content: flex-start;
      padding-left: 60px;
    }
    button.join-round-table-lite.hide-bussiness-card {
      width: 100%;
      justify-content: flex-start;
      padding-left: 60px;
    }
    .expo-tabs {
      display: flex;
      justify-content: center;
    }
    .exchange-businesscard-lite {
      width: 50%;
      font-size: 14px;
      background-size: 27px;
      padding-left: 37px;
    }
    .join-round-table-lite {
      width: 45%;
      font-size: 14px;
    }
    .join-round-table-lite {
      padding-left: 30px;
      background-size: 24px;
    }
    .mobile-single-contact {
      padding: 8px;
    }
    .mobile-contact-options ul li a img {
      height: 30px;
      width: 30px;
    }

    .mobile-contact-options {
      width: 100%;
    }

    .mobile-contact-options ul {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .mobile-cont-desc {
      padding-left: 0px;
    }
    .mobile-cont-desc h4 {
      font-size: 16px;
      margin-bottom: 0;
    }
    .mobile-cont-desc p {
      font-size: 14px;
      margin-bottom: 0;
    }
    .mobile-contact-options ul li a {
      margin: 10px;
    }
    .mobile-contacts-wrap {
      padding: 15px 8px;
    }
    .mobile-cont-dect-wrap .contact-image {
      height: 40px;
      width: 40px;
    }
    .mobile-contact-image-wrapper {
      height: 40px;
      width: 48px;
    }
    .collaterals-file h4 {
      font-size: 16px;
    }
    .play-video-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .booth-inner-lite {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    .booth-inner-light img {
      max-width: 100%;
      height: 100%;
    }
    .booth-inner-light img.play-video-btn {
      height: auto !important;
    }
    .business-card-modal .modal-body textarea {
      width: 100%;
      height: 200px;
      border-radius: 6px;
      border: 1px solid #dfdfdf;
      padding: 10px;
      font-size: 14px;
      color: #838383;
      resize: none;
    }
    .business-card-modal .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0rem 1rem;
      border-bottom: none;
    }
    .business-card-modal button.close {
      position: relative;
      top: 0;
      right: 0;
      z-index: 99;
    }
    .business-card-modal .btn-primary {
      color: #fff;
      background-color: #19a883;
      border-color: #19a883;
    }
    .collaterals-download {
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 0 0 30px;
    }
    .collaterals-download img {
      max-width: 100%;
      height: 100%;
    }
    .collateral-file-icon-img img {
      max-width: 100%;
      height: 100%;
    }
    .collateral-file-icon-img {
      width: 30px;
      height: 30px;
      flex: 30px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .booth-inner-lite iframe {
      width: 100%;
      height: 190px;
    }
    .booth-details-small .booth-image {
      height: 100px;
      width: 30%;
      flex: 30% 0 0;
    }
    .mobile-booth-head-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
    .booth-head-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .back-to-hall {
      height: 25px;
      width: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      margin-right: 10px;
    }
    .back-to-hall img {
      max-width: 100%;
      height: 100%;
    }
    .booth-mobile-slide-btn ul {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .booth-mobile-slide-btn ul li {
      display: inline-block;
    }
    .booth-mobile-slide-btn ul li:last-child {
      margin-right: 0;
    }
    .booth-mobile-slide-btn ul li span {
      display: inline-flex;
      height: 25px;
      width: 25px;
      justify-content: center;
      align-items: center;
    }
    .game-wrap {
      position: fixed;
      bottom: 0;
      z-index: 99;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801; /* Old browsers */
      background: -moz-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff6801', endColorstr='#f62290',GradientType=1 ); /* IE6-9 */
      width: 100%;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      h3 {
        margin: 0;
        color: #fff;
        font-weight: 600;
        font-size: 24px;
        padding-left: 10px;
      }
    }
    .v-dialog {
      box-shadow: none !important;
    }
    .code-reveal-btn {
      background: #fff;
      margin-right: 10px;
      padding: 8px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      width: 212px;
      p {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0;
        color: #f62290;
        font-weight: 600;
      }
    }
    .mobile-scavenger-dialog {
      height: 390px;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ff6801+0,f62290+73,f62290+73 */
      background: #ff6801; /* Old browsers */
      background: -moz-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        top,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to bottom,
        #ff6801 0%,
        #f62290 73%,
        #f62290 73%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff6801', endColorstr='#f62290',GradientType=0 ); /* IE6-9 */
      border-radius: 25px;

      .mobile-scavenger-dialog-inner {
        height: 100%;
        padding: 22px;
        text-align: center;

        p {
          color: #fff;
          margin-top: 17px;
          width: 150px;
          margin: 12px auto 0;
          font-size: 18px;
        }
        .mobile-reveal-code h4 {
          display: inline-block;
          background: #fff;
          padding: 5px 8px;
          border-radius: 10px;
          margin-top: 10px;
        }
        h3 {
          color: #fff;
          font-size: 50px;
          margin: 0;
          line-height: 46px;
        }
      }
    }
  }
}
</style>
<script>
import Vue from "vue";
import db from "../components/firebaseInit";
import router from "../router";
import store from "../store";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
import moment from "moment";
import axios from "axios";
import APIs from "@/components/APIInit";
import RequestMeeting from "@/components/RequestMeeting.vue";
let $ = jQuery;

var self;
var interval = null;
import { bus } from "../main";
export default {
  components: {
    RequestMeeting,
  },
  data() {
    return {
      eventRegSuccessDialog: false,
      registering: false,
      isPodiumEnabled: false,
      podiumTitle: null,
      podiumDescription: null,
      ctaLink: null,
      knowMoreLink: null,
      AllowMoreThan1tojoinRepInVideoCall: false,
      ShowRepActiveStatus: false,
      EnableExhibitorRepVideoCall: false,
      ExhParticipance: [],
      headerText: "Exhibit Hall",
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      MappedContacts: [],
      MappedRoundTables: [],
      BroadcastData: [],
      exid: null,
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      lastVisible: null,
      ExhibitorData: [],
      DropFilter: [],
      HotspotSettings: [],
      nxt: null,
      prv: null,
      loadedScript: 0,
      timerLoader: 0,
      tid: null,
      eventcollectionname: "",
      roundtableData: [],
      eventId2: "",
      userid: "",
      clientid: "",
      roundtableTopicData: [],
      roundtableAttendeesData: [],
      arrMappedAttndees: [],
      roundtableIds: [],
      ExhibitorSettings: [],
      ExhibitorFiles: [],
      ExhibitorLinks: [],
      displayPic: null,
      Username: null,
      ExpoHallBackgroundImage: "",
      JoinTheConversationText: "",
      isBusinessCardApiNew: false,
      APIs: APIs,
      showAerialView: false,
      showBirdView: false,
      alreadyChatted: false,
      showVideoFlg: false,
      showBusinessCardBtn: false,
      GlobalKeysData: {
        // id: "SN1591285924312",
        // Name: "Opening Key Note",
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        // UserID: "84607270",
        //  eventID: this.eventId,
        // chanelID: "GB" + "_4733" + "_" + "SN1591285924312",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",
      defaultChatMsg: null,
    };
  },

  computed: {
    MeetingSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        Slot: obj.MeetingSettings[0].Slot,
        StartDate: obj.MeetingSettings[0].StartDate,
        EndDate: obj.MeetingSettings[0].EndDate,
        AvailabilityFromTime: obj.MeetingSettings[0].AvailabilityFromTime,
        AvailabilityToTime: obj.MeetingSettings[0].AvailabilityToTime,
      };
    },

    BoothName() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.selExhibitorID;
    },
  },
  methods: {
    Register(boothId, eventShortName, eventFullName) {
      debugger;
      self.registering = true;
      var user = self.getSessionUserProfile();
      if (user && user.UserId && user.Email != "visitor@e2m.live") {
        let headers = {
          "Content-Type": "application/json",
        };
        var requestData = {};

        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientId,
          },
          PrimaryData: {
            //UserId: user.UserId,
            FirstName: user.FirstName,
            LastName: user.LastName,
            Email: user.Email,
            Phone: user.Phone,
            Company: user.Company,
            Designation: user.Designation,
            ProfileImageURL: user.ProfileImageURL,
            "Event Short Name": eventShortName,
            "Event Full Name": eventFullName,
          },
          MetaData: {},
        };
        axios
          .post(self.APIs.AddToSpreadsheet, requestData, { headers: headers })
          .then(function (res) {
            debugger;
            self.registering = false;
            if (res.data.status == 0) {
              self.eventRegSuccessDialog = true;
              console.log("res-----", res);
            }
          })
          .catch(() => {
            self.registering = false;
            console.log("error");
          });
      } else {
        self.registering = false;
        let eventId = self.getEventId();
        router.push(
          "/?&event_id=" +
            eventId +
            "&redirect_url=/exhibitorsview/" +
            boothId +
            "/" +
            eventShortName
        );
      }
    },
    GoForInternalPlayerE2O(
      ExhibitorId,
      chatToId,
      StreamingClient,
      Zoom_Detail
    ) {
      $(".tooltip").tooltip("hide");

      let streamClien = StreamingClient;
      if (streamClien) {
        streamClien = streamClien.trim().toLowerCase();
      }
      if (
        streamClien == "zoom" &&
        Zoom_Detail &&
        Zoom_Detail.id &&
        Zoom_Detail.join_url
      ) {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var attendeeId = obj.user[0].id;
        var first_name = obj.user[0].fname;
        var last_name = obj.user[0].lname;

        if (Zoom_Detail && Zoom_Detail.id && Zoom_Detail.join_url) {
          if (attendeeId == chatToId) {
            var hlink =
              Zoom_Detail.start_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(hlink, "_blank");
          } else {
            var link =
              Zoom_Detail.join_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(link, "_blank");
          }
        } else {
          alert(self.zoomErrorMsg);
          self.hideLoader();
        }
      } else {
        var exhiColForInternalPlayer =
          ExhibitorId + "-" + chatToId.toString() + "_e2o";
        router.push({ path: "/livestage/" + exhiColForInternalPlayer });
      }
    },
    GoForInternalPlayerRT(tableId, StreamingClient, Zoom_Detail, hostId) {
      if (StreamingClient.toLowerCase() == "zoom") {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var attendeeId = obj.user[0].id;
        var first_name = obj.user[0].fname;
        var last_name = obj.user[0].lname;

        if (Zoom_Detail && Zoom_Detail.id) {
          if (attendeeId == hostId) {
            var hlink =
              Zoom_Detail.start_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(hlink, "_blank");
          } else {
            var link =
              Zoom_Detail.join_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(link, "_blank");
          }
        } else {
          alert(self.zoomErrorMsg);
          self.hideLoader();
        }
      } else {
        var chId = tableId + "_exrt";
        $(".tooltip").tooltip("hide");
        router.push({ path: "/livestage/" + chId });
      }
    },
    getUpdatedStatus: function () {
      // console.log("EXHI contacts:- " + self.ExhibitorData[0].MappedContacts);
      // alert(
      //   "self.EnableExhibitorRepVideoCall2 - " +
      //     self.EnableExhibitorRepVideoCall
      // );

      $.each(self.ExhibitorData[0].MappedContacts, function (index, value) {
        var objusr = JSON.parse(window.localStorage.getItem("my-app"));
        // console.log("loggedin userid:- " + objusr.user[0].id);
        let streamingClient = value.StreamingClient;
        if (!streamingClient) {
          streamingClient = "Web";
        }
        var statusClass = "away";
        if (streamingClient.trim().toLowerCase() == "zoom") {
          if (self.EnableExhibitorRepVideoCall) {
            statusClass = "online";
            self.ExhibitorData[0].MappedContacts[index].VideoCallEnable = true;
            self.ExhibitorData[0].MappedContacts[index].statusClass =
              statusClass;
          }
        } else {
          if (objusr.user[0].id === value.AttendeeId) {
            if (self.EnableExhibitorRepVideoCall) {
              self.ExhibitorData[0].MappedContacts[
                index
              ].VideoCallEnable = true;

              self.ExhibitorData[0].MappedContacts[index].statusClass =
                statusClass;

              self.ExhibitorData = self.ExhibitorData.filter(function (
                valueExh
              ) {
                return valueExh.AttendeeId !== 0;
              });
            } else {
              self.ExhibitorData[0].MappedContacts[
                index
              ].VideoCallEnable = false;

              self.ExhibitorData[0].MappedContacts[index].statusClass =
                statusClass;

              self.ExhibitorData = self.ExhibitorData.filter(function (
                valueExh
              ) {
                return valueExh.AttendeeId !== 0;
              });
            }
          } else {
            //  var statusClass = "away";

            var VideoCallEnable = false;
            // $("#spnStatus" + value.AttendeeId).removeClass();
            // $("#spnStatus" + value.AttendeeId).addClass(statusClass);
            self.ExhibitorData[0].MappedContacts[index].statusClass =
              statusClass;

            if (self.EnableExhibitorRepVideoCall) {
              self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
                VideoCallEnable;
            } else {
              self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
                self.EnableExhibitorRepVideoCall;
            }
          }

          // self.ExhibitorData[0].MappedContacts[index].ShowRepActiveStatus =
          //   self.ShowRepActiveStatus;

          //var col_name = self.exid + "-" + value.AttendeeId + "_o2o";
          var col_name = self.exid + "-" + value.AttendeeId + "_e2o"; //418000-221002_o2o

          var obj = JSON.parse(window.localStorage.getItem("my-app"));
          db.collection(obj.eventcollectionname)
            .doc("UserVideoActivity")
            .collection("ExhibitorMeeting")
            .doc(col_name)
            .collection("Participances")
            .onSnapshot((querySnapshot) => {
              var CurrentRepresentativeStatus = true;

              if (querySnapshot.docs.length > 0) {
                var cnt = 0;
                querySnapshot.forEach((doc) => {
                  var curDoc = doc.data();
                  var obj = new Object();
                  obj.participants = curDoc.AttendeeId;
                  obj.status = curDoc.IsActive;
                  self.ExhParticipance.push(obj);
                  if (curDoc.IsActive) {
                    cnt++;
                  }

                  if (value.AttendeeId == curDoc.AttendeeId) {
                    CurrentRepresentativeStatus = curDoc.IsActive;
                    console.log("value.AttendeeId1  - " + value.AttendeeId);
                    console.log(
                      "CurrentRepresentativeStatus1 - " +
                        CurrentRepresentativeStatus
                    );
                  }
                });
                var attIsActive = self.ExhParticipance.filter(function (
                  valueExh
                ) {
                  return value.AttendeeId == valueExh.participants;
                });
                if (attIsActive <= 0) {
                  statusClass = "away";
                  //  $("#lnkVideoCall" + value.AttendeeId).attr("disabled", "true");
                  VideoCallEnable = false;
                } else {
                  console.log(
                    "CurrentRepresentativeStatus2 - " +
                      CurrentRepresentativeStatus
                  );
                  if (CurrentRepresentativeStatus) {
                    if (cnt >= 2) {
                      statusClass = "offline"; //busy
                      if (self.AllowMoreThan1tojoinRepInVideoCall) {
                        VideoCallEnable = true;
                      } else {
                        VideoCallEnable = false;
                      }
                    } else if (cnt < 2) {
                      if (cnt > 0) {
                        statusClass = "online";
                        VideoCallEnable = true;
                      } else {
                        statusClass = "away";
                        VideoCallEnable = false;
                      }
                    }
                  } else {
                    statusClass = "away";
                    VideoCallEnable = false;
                  }
                }

                // self.ExhibitorData[0].MappedContacts.statusClass = statusClass;
                // value.statusClass = statusClass;

                //++++++++++++++++++++++ video call ICON show/hide (for now - if EnableExhibitorRepVideoCall is false , the video icon will get INACTIVE [irrespective of any status])++++++++++++++++++++++++++++++++++++++++++++
                if (self.EnableExhibitorRepVideoCall) {
                  if (obj.user[0].id === value.AttendeeId) {
                    self.ExhibitorData[0].MappedContacts[
                      index
                    ].VideoCallEnable = true;
                  } else {
                    self.ExhibitorData[0].MappedContacts[
                      index
                    ].VideoCallEnable = VideoCallEnable;
                  }
                } else {
                  self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
                    self.EnableExhibitorRepVideoCall;
                }
                // self.ExhibitorData[0].MappedContacts[
                //   index
                // ].VideoCallEnable = VideoCallEnable;
                //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

                self.ExhibitorData = self.ExhibitorData.filter(function (
                  valueExh
                ) {
                  return valueExh.AttendeeId !== 0;
                });

                $("#spnStatus" + value.AttendeeId).removeClass();
                $("#spnStatus" + value.AttendeeId).addClass(statusClass);
              }
            });
        }
      });
    },
    getUpdatedStatusOLD: function () {
      // console.log("EXHI contacts:- " + self.ExhibitorData[0].MappedContacts);
      // alert(
      //   "self.EnableExhibitorRepVideoCall2 - " +
      //     self.EnableExhibitorRepVideoCall
      // );

      $.each(self.ExhibitorData[0].MappedContacts, function (index, value) {
        var objusr = JSON.parse(window.localStorage.getItem("my-app"));
        // console.log("loggedin userid:- " + objusr.user[0].id);

        var statusClass = "away";

        if (objusr.user[0].id === value.AttendeeId) {
          if (self.EnableExhibitorRepVideoCall) {
            //if loggedin user is REPRESENTATIVE
            //  statusClass = "online";
            //VideoCallEnable = true;
            // $("#spnStatus" + objusr.user[0].id).removeClass();
            // $("#spnStatus" + objusr.user[0].id).addClass(statusClass);

            self.ExhibitorData[0].MappedContacts[index].VideoCallEnable = true;

            self.ExhibitorData[0].MappedContacts[index].statusClass =
              statusClass;

            self.ExhibitorData = self.ExhibitorData.filter(function (valueExh) {
              return valueExh.AttendeeId !== 0;
            });
          } else {
            self.ExhibitorData[0].MappedContacts[index].VideoCallEnable = false;

            self.ExhibitorData[0].MappedContacts[index].statusClass =
              statusClass;

            self.ExhibitorData = self.ExhibitorData.filter(function (valueExh) {
              return valueExh.AttendeeId !== 0;
            });
          }
        } else {
          //  var statusClass = "away";

          var VideoCallEnable = false;
          // $("#spnStatus" + value.AttendeeId).removeClass();
          // $("#spnStatus" + value.AttendeeId).addClass(statusClass);
          self.ExhibitorData[0].MappedContacts[index].statusClass = statusClass;

          if (self.EnableExhibitorRepVideoCall) {
            self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
              VideoCallEnable;
          } else {
            self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
              self.EnableExhibitorRepVideoCall;
          }
        }

        // self.ExhibitorData[0].MappedContacts[index].ShowRepActiveStatus =
        //   self.ShowRepActiveStatus;

        var col_name = self.exid + "-" + value.AttendeeId + "_o2o"; //418000-221002_o2o

        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        db.collection(obj.eventcollectionname)
          .doc("UserVideoStatus")
          .collection(col_name)
          .onSnapshot((querySnapshot) => {
            var CurrentRepresentativeStatus = true;

            if (querySnapshot.docs.length > 0) {
              var cnt = 0;
              querySnapshot.forEach((doc) => {
                var curDoc = doc.data();
                var obj = new Object();
                obj.participants = curDoc.AttendeeId;
                obj.status = curDoc.IsActive;
                self.ExhParticipance.push(obj);
                if (curDoc.IsActive) {
                  cnt++;
                }

                if (value.AttendeeId == curDoc.AttendeeId) {
                  CurrentRepresentativeStatus = curDoc.IsActive;
                  console.log("value.AttendeeId1  - " + value.AttendeeId);
                  console.log(
                    "CurrentRepresentativeStatus1 - " +
                      CurrentRepresentativeStatus
                  );
                }
              });
              var attIsActive = self.ExhParticipance.filter(function (
                valueExh
              ) {
                return value.AttendeeId == valueExh.participants;
              });
              if (attIsActive <= 0) {
                statusClass = "away";
                //  $("#lnkVideoCall" + value.AttendeeId).attr("disabled", "true");
                VideoCallEnable = false;
              } else {
                console.log(
                  "CurrentRepresentativeStatus2 - " +
                    CurrentRepresentativeStatus
                );
                if (CurrentRepresentativeStatus) {
                  if (cnt >= 2) {
                    statusClass = "offline"; //busy
                    if (self.AllowMoreThan1tojoinRepInVideoCall) {
                      VideoCallEnable = true;
                    } else {
                      VideoCallEnable = false;
                    }
                  } else if (cnt < 2) {
                    if (cnt > 0) {
                      statusClass = "online";
                      VideoCallEnable = true;
                    } else {
                      statusClass = "away";
                      VideoCallEnable = false;
                    }
                  }
                } else {
                  statusClass = "away";
                  VideoCallEnable = false;
                }
              }

              // self.ExhibitorData[0].MappedContacts.statusClass = statusClass;
              // value.statusClass = statusClass;

              //++++++++++++++++++++++ video call ICON show/hide (for now - if EnableExhibitorRepVideoCall is false , the video icon will get INACTIVE [irrespective of any status])++++++++++++++++++++++++++++++++++++++++++++
              if (self.EnableExhibitorRepVideoCall) {
                if (obj.user[0].id === value.AttendeeId) {
                  self.ExhibitorData[0].MappedContacts[
                    index
                  ].VideoCallEnable = true;
                } else {
                  self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
                    VideoCallEnable;
                }
              } else {
                self.ExhibitorData[0].MappedContacts[index].VideoCallEnable =
                  self.EnableExhibitorRepVideoCall;
              }
              // self.ExhibitorData[0].MappedContacts[
              //   index
              // ].VideoCallEnable = VideoCallEnable;
              //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

              self.ExhibitorData = self.ExhibitorData.filter(function (
                valueExh
              ) {
                return valueExh.AttendeeId !== 0;
              });

              $("#spnStatus" + value.AttendeeId).removeClass();
              $("#spnStatus" + value.AttendeeId).addClass(statusClass);
            }
          });
        // }
      });

      // for (
      //   var i = 0;
      //   i < self.ExhibitorData[0].MappedContacts.length - 1;
      //   i++
      // ) {
      //   console.log("i- " + i);
      //   // if (self.ExhibitorData[0].MappedContacts[j].AttendeeId === "221002") {
      //   var col_name =
      //     "/OAUAT_E1591907102804_342340-368061_o2o/Participance/Participances";
      //   var statusClass = "online";
      //   db.collection(col_name).onSnapshot((querySnapshot) => {
      //     var cnt = 0;
      //     querySnapshot.forEach((doc) => {
      //       var curDoc = doc.data();
      //       if (curDoc.IsActive) {
      //         cnt++;
      //       }
      //     });
      //     if (cnt >= 2) {
      //       statusClass = "offline"; //busy
      //     } else if (cnt < 2) {
      //       statusClass = "online";
      //     }
      //
      //     $(
      //       "#spnStatus" + self.ExhibitorData[0].MappedContacts[i].AttendeeId
      //     ).removeClass();
      //     $(
      //       "#spnStatus" + self.ExhibitorData[0].MappedContacts[i].AttendeeId
      //     ).addClass(statusClass);

      //     // self.updateSingleExhibitor(
      //     //   self.ExhibitorData[0].MappedContacts[j].AttendeeId,
      //     //   statusClass
      //     // );
      //     //self.ExhibitorData[0].MappedContacts[j].statusClass = statusClass;
      //   });
      //   //}
      // }
    },
    loopArray: function (arr) {
      var obj = [];
      var i;

      for (i = 0; i < arr.length; i++) {
        let socialkeys = Object.keys(arr[i]);
        let socialvaues = Object.values(arr[i]);
        if (socialvaues[0] !== "") {
          if (socialvaues[0].indexOf("http") < 0) {
            socialvaues[0] = "http://" + socialvaues[0];
          }
        }
        obj.push({ key: socialkeys[0], value: socialvaues[0] });
      }
      this.sortedSocialLinks = obj;
      this.sortedSocialLinks.sort(function (x, y) {
        let a = x.key.toUpperCase(),
          b = y.key.toUpperCase();
        return a == b ? 0 : a > b ? 1 : -1;
      });
    },
    getDates: function (startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };
      while (currentDate <= endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },

    InitModal(ReqIndex, parAttendeeId) {
      $("#ReqMeeting" + ReqIndex + " .calendar-wrap").show();
      $("#ReqMeeting" + ReqIndex + " .modal-body-wrapper2").hide();
      $("#ReqMeeting" + ReqIndex + " .modal-body-wrapper3").hide();

      localStorage.setItem("AttendeeId", parAttendeeId);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      //Receiver id
      this.createAvailableMeetingSlots(parAttendeeId);
      //Sender id
      this.createAvailableMeetingSlots(obj.user[0].id);

      //  this.getAvailableMeetingSlots(parAttendeeId);
    },
    OpenRequestMeeting(data) {
      console.log("data=====", data);

      if (data.ProfilePictureURL != "") {
        var AttendeeImgPath = data.ProfilePictureURL;

        if (AttendeeImgPath != null && AttendeeImgPath != "") {
          document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
        }

        $("#ReqAttendeeImage").show();
        if (document.getElementById("ReqdivImgHldText")) {
          document.getElementById("ReqdivImgHldText").innerText = "";
          $("#ReqdivImgHldText").hide();
        }
      } else {
        var Initials = document.getElementById("dvImgeHldText").innerText;
        $("#ReqAttendeeImage").attr("src", "");
        $("#ReqAttendeeImage").hide();
        if (document.getElementById("ReqdivImgHldText")) {
          document.getElementById("ReqdivImgHldText").innerHTML =
            "<h4>" + Initials + "</h4>";
          $("#ReqdivImgHldText").show();
        }
      }

      if (document.getElementById("ReqAttendeeName")) {
        document.getElementById("ReqAttendeeName").innerText = data.Name;
      }
      if (document.getElementById("ReqAttendeeNameh4")) {
        document.getElementById("ReqAttendeeNameh4").innerText = data.Name;
      }
      if (document.getElementById("ReqAttendeeTitle")) {
        document.getElementById("ReqAttendeeTitle").innerText =
          data.Designation;
      }
      if (document.getElementById("ReqAttendeeCompany")) {
        document.getElementById("ReqAttendeeCompany").innerText = data.Company;
      }
      if (data.Email) {
        if (data.Email) {
          document.getElementById("ReqAttendeeEmail").href = data.Email;
          if (
            document.getElementById("ReqAttendeeEmail").href.indexOf("mailto") <
            0
          ) {
            $("#ReqAttendeeEmail").text(data.Email);
            document.getElementById("ReqAttendeeEmail").href =
              "mailto:" + document.getElementById("ReqAttendeeEmail").href;
          }
          $("#ReqAttendeeEmail").parent().show();
        } else {
          $("#ReqAttendeeEmail").parent().hide();
        }
      } else {
        $("#ReqAttendeeEmail").parent().hide();
      }

      if (data.Phone) {
        if (data.Phone) {
          document.getElementById("ReqAttendeePhone").href = data.Phone;
          if (
            document.getElementById("ReqAttendeePhone").href.indexOf("tel") < 0
          ) {
            $("#ReqAttendeePhone").text(data.Phone);
            document.getElementById("ReqAttendeePhone").href =
              "tel:" + document.getElementById("ReqAttendeePhone").href;
          }
          $("#ReqAttendeePhone").parent().show();
        } else {
          $("#ReqAttendeePhone").parent().hide();
        }
      } else {
        $("#ReqAttendeePhone").parent().hide();
      }

      $("#ReqAttendeeWebsite").parent().hide();
      $("#aFacebok").hide();
      $("#aTwitter").hide();
      $("#aLikedin").hide();
      $("#hdnAttendeeId").val(data.AttendeeId);
      var hdnattendeeId = data.AttendeeId;
      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: { attendeeId: hdnattendeeId },
      });
      instance.$mount();
      $("#myModal2").hide();
      $(".modal-backdrop").hide();
    },

    createAvailableMeetingSlots: function (attendeeId) {
      var availableSlot = [];
      var AvailabilityFromTime;
      var AvailabilityToTime;
      var AvailableMeetingSlotsId;
      // var AvailableMeetingSlots=[];

      if (this.MeetingSettings.AvailabilityFromTime != null) {
        AvailabilityFromTime = Math.round(
          this.MeetingSettings.AvailabilityFromTime / 3600
        );
      }
      if (this.MeetingSettings.AvailabilityToTime != null) {
        AvailabilityToTime = Math.round(
          this.MeetingSettings.AvailabilityToTime / 3600
        );
      }
      //
      availableSlot.push(
        moment(AvailabilityFromTime, ["h:mm A"]).format("hh:mm A")
      );

      var StartSlotTime = moment(AvailabilityFromTime, ["h:mm A"]);
      var EndSlotTime = moment(AvailabilityToTime, ["h:mm A"]);

      for (let i = AvailabilityFromTime; StartSlotTime < EndSlotTime; i++) {
        let time = moment(availableSlot[i - AvailabilityFromTime], ["h:mm A"])
          .add(this.MeetingSettings.Slot, "minutes")
          .format("hh:mm A");

        availableSlot.push(time);
        StartSlotTime = moment(time, ["h:mm A"]);
      }

      var MSobj = JSON.parse(window.localStorage.getItem("my-app"));

      var MeetingStartDate = new Date();
      var MeetingEndDate = new Date(
        MSobj.MeetingSettings[0].EndDate.seconds * 1000
      );

      var dates = this.getDates(MeetingStartDate, MeetingEndDate);
      //
      dates.forEach(function (MeetingsDate) {
        console.log(MeetingsDate);

        for (let i = 0; i < availableSlot.length - 1; i++) {
          //

          AvailableMeetingSlotsId =
            moment(MeetingsDate).format("MMMDD") +
            "_" +
            availableSlot[i] +
            "_" +
            availableSlot[i + 1];

          self.SaveAvailableMeetingSlots(attendeeId, AvailableMeetingSlotsId);
        }
      });
    },
    SaveAvailableMeetingSlots: function (attendeeId, AvailableMeetingSlotsId) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var AvailableMeetingSlots = "AvailableMeetingSlots";
      var MeetingTime = AvailableMeetingSlotsId.split("_");

      var MdocRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(attendeeId)
        .collection(AvailableMeetingSlots)
        .doc(AvailableMeetingSlotsId);

      MdocRef.get()
        .then(function (doc) {
          if (!doc.exists) {
            //

            var docObj = new Object();
            docObj.AvailableMeetingSlotsId = AvailableMeetingSlotsId;
            docObj.StartDate = MeetingTime[0];
            docObj.StartDatetime = MeetingTime[1];
            docObj.EndDateTime = MeetingTime[2];

            MdocRef.set(docObj)
              .then(function () {
                console.log("AvailableMeetingSlots Created ");
              })
              .catch(function (error) {
                console.error("Error AvailableMeetingSlots: ", error);
              });
          }
        })
        .catch(function (error) {
          console.error("Error creating AvailableMeetingSlots: ", error);
        });
    },
    StartBroadcast: function (
      BroadcastStartURL,
      videoParamsEncryptURL,
      IsBroadcastInNewTab,
      ExhibitorId,
      UserFirstname,
      ChatFirstname,
      chatToId,
      broadcastbaseURL,
      BroadcastURL,
      BroadcastvalidityHours,
      videoId,
      videoCert,
      BroadcastID,
      ChannelPrefix,
      BroadcastSpeakerApiUrl,
      BroadcastAttendeeApiUrl,
      IsOpenInternalPlayer,
      StreamingClient,
      Zoom_Detail
    ) {
      console.log(IsOpenInternalPlayer);
      if (IsOpenInternalPlayer == 1) {
        //var exhiColForInternalPlayer =
        //  ExhibitorId + "-" + chatToId.toString() + "_e2o";
        self.GoForInternalPlayerE2O(
          ExhibitorId,
          chatToId,
          StreamingClient,
          Zoom_Detail
        );
      } else {
        var OnAirVCount = this.readCookieForVideo("onairvcount");
        var videoLaunchFlag = true;
        if (OnAirVCount != null) {
          if (parseInt(OnAirVCount) >= 1) {
            if (
              !confirm(
                "An active OnAir video seems to be running, it is recommended to open one video at a time for best performance. Do you still want to open the video in another tab?"
              )
            ) {
              videoLaunchFlag = false;
            }
          }
        }

        if (videoLaunchFlag) {
          // alert(broadcastbaseURL);
          console.log("BroadcastSpeakerApiUrl = " + BroadcastSpeakerApiUrl);
          console.log("BroadcastAttendeeApiUrl = " + BroadcastAttendeeApiUrl);
          var obj = JSON.parse(window.localStorage.getItem("my-app"));
          var clntid = obj.client[0].id;
          var usrid = obj.user[0].id;
          var evntid = obj.eventid;

          var name = obj.user[0].name;
          // var userfname = obj.user[0].fname;

          // alert(name);
          //  alert(userfname);

          // alert(usrid);
          // alert(evntid);

          // varchannelName = "GB_4720_144305-144281_o2o";

          /* if (parseInt(UserID) < parseInt(value.ID)) {
                    varchannelName = E2MConfig.channelPrefix + "_" + evntid + "_" + usrid + "-" + value.ID + "_o2o";
                } else {
                    varchannelName = E2MConfig.channelPrefix + "_" + evntid + "_" + value.ID + "-" + usrid + "_o2o";
                }*/
          var varchannelName = "";

          varchannelName =
            ChannelPrefix +
            "_" +
            evntid.substring("1") +
            "_" +
            ExhibitorId +
            "-" +
            chatToId.toString() +
            "_o2o";

          // ExhibitorId-chatToId_e2o";

          //  alert(varchannelName);
          //alert("chatToId - " + chatToId);
          /* if (parseInt(usrid) < parseInt(chatToId)) {
        //   alert("1");
        varchannelName =
          ChannelPrefix +
          "_" +
          evntid.substring("1") +
          "_" +
          usrid +
          "-" +
          chatToId.toString() +
          "_o2o";
      } else {
        // alert("2");
        varchannelName =
          ChannelPrefix +
          "_" +
          evntid.substring("1") +
          "_" +
          chatToId.toString() +
          "-" +
          usrid +
          "_o2o";
      }*/
          // alert(varchannelName);
          console.log(varchannelName);
          /*  var postData = {
        app: {
          id: videoId,
          certificate: videoCert
        },
        channelName: varchannelName,
        userID: 0,
        validityHours: 72
      };
      var url = "https://onairapi.e2m.live/get-session-token-speaker";
      alert(url);

      self.callAjaxService(url, postData, "", true, function(response) {
        chatURL =
          BroadcastURL +
          "?appID=" +
          BroadcastID +
          "&channelID=" +
          varchannelName +
          "&token=" +
          response.token +
          "&isScreen=0&sname=" +
          UserFirstname +
          " and " +
          ChatFirstname +
          " [Video Call]&stime=&uid=" +
          usrid;
        alert(JSON.stringify(chatURL));
        $("#iframeBroadcast").attr(
          "src",
          chatURL + "&t=" + new Date().getTime()
        );
        $("#modalOpenBroadcast").modal();
      });*/

          //  var broadcastType = "startbroadcast";

          //var SessionTitle = userfname + " and " + ChatFirstname + " [Video Call]";
          var SessionTitle = UserFirstname + " - " + name + " [Video Call] ";

          /*var reqData2 = {
        BroadcastID: BroadcastID,
        BroadcastCertificate: videoCert,
        BroadcastSpeakerApiUrl: BroadcastSpeakerApiUrl,
        BroadcastAttendeeApiUrl: BroadcastAttendeeApiUrl,
        BroadcastvalidityHours: BroadcastvalidityHours,
        chanelID: varchannelName,
        UserID: usrid, // "24183956", //usrid,
        eventID: parseInt(evntid.substring("1")),
        BroadCastType: broadcastType,
        SessionTitle: SessionTitle,
        BroadcastURL: BroadcastURL
      };
      console.log(JSON.stringify(reqData2));
      this.callAjaxService(
        "GetVideoUrlAPI",
        reqData2,
        "",
        false,
        broadcastbaseURL,
        function(_data2) {
          // var obj = JSON.parse(window.localStorage.getItem("my-app"));
          //var email = obj.user[0].Email;
          var brdcstUrl = _data2.broadcastURL + "&cid=" + clntid; //+ "&e=" + email;
          console.log(brdcstUrl);

          //alert(JSON.stringify(brdcstUrl));
          //alert(brdcstUrl);
          // $("#iframeBroadcast").attr(
          //   "src",
          //   _data2.broadcastURL + "&t=" + new Date().getTime()
          // );

          if (IsBroadcastInNewTab == 1) {
            window.open(brdcstUrl, "_blank");
          } else {
            $("#iframeBroadcast").attr(
              "src",
              brdcstUrl + "&t=" + new Date().getTime()
            );
            $("#modalOpenBroadcast").modal();
          }
        }
      );*/

          //Video URL with encrypted parameter
          // alert(usrid);
          console.log(
            "Parameters - url - " +
              videoParamsEncryptURL +
              "broadcastTypeUrl- " +
              BroadcastStartURL +
              "BroadcastvalidityHours - " +
              BroadcastvalidityHours +
              "channelid - " +
              varchannelName +
              "usrid - " +
              usrid +
              "SessionTitle - " +
              SessionTitle +
              " clntid - " +
              clntid
          );

          this.getEncryptedVideoURLParams(
            videoParamsEncryptURL,
            BroadcastStartURL,
            BroadcastvalidityHours,
            varchannelName,
            usrid,
            SessionTitle,
            clntid,
            function (videoURL, UserID) {
              // alert(videoURL);
              console.log(UserID);
              if (IsBroadcastInNewTab) {
                //window.parent.location.reload();
                window.open(videoURL, "_blank");
              } else {
                $("#iframeBroadcast").attr(
                  "src",
                  videoURL + "&t=" + new Date().getTime()
                );
                $("#modalOpenBroadcast").modal();
              }
            }
          );
        }
      }
    },
    getExhibitorDetails: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname) //"OA_UAT_C1592010308300E1592010479212") //OA_UAT_C1591205467009E1591206650065")
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .where("ExhibitorId", "==", obj.selExhibitorID)
        //.where("ExhibitorId", "==", "418000")
        .get()
        .then((querySnapshot) => {
          this.ExhibitorData = [];
          querySnapshot.forEach((doc) => {
            $(".aPointer").css("border", "1px solid red");
            var socLinks = doc.data().SocialLinks;

            this.loopArray(socLinks);
            socLinks = this.sortedSocialLinks;

            if (doc.data().PodiumDetails) {
              self.isPodiumEnabled = true;
              self.podiumTitle = doc.data().PodiumDetails.Title
                ? doc.data().PodiumDetails.Title
                : null;
              self.podiumDescription = doc.data().PodiumDetails.Description
                ? doc.data().PodiumDetails.Description
                : null;
              self.ctaLink = doc.data().PodiumDetails.CTALink
                ? doc.data().PodiumDetails.CTALink
                : null;
              self.knowMoreLink = doc.data().PodiumDetails.KnowMoreLink
                ? doc.data().PodiumDetails.KnowMoreLink
                : null;
            } else {
              self.isPodiumEnabled = false;
              self.podiumTitle = null;
              self.podiumDescription = null;
              self.ctaLink = null;
              self.knowMoreLink = null;
            }

            this.ExhibitorData.push({
              id: doc.id,
              Name: doc.data().Name,
              Logo: doc.data().Logo,
              Email: doc.data().Email,
              Category: doc.data().Category,
              HtmlCode: doc.data().HtmlCode ? doc.data().HtmlCode : "",
              BoothNo: doc.data().BoothNo,
              HotspotImageUrL: doc.data().HotspotImageURL,
              Website: doc.data().Website,
              Profile: doc.data().Profile,
              Phone: doc.data().Phone,
              Image: doc.data().Logo,
              SocialLinks: socLinks,
              MappedContacts: doc.data().MappedContacts
                ? doc.data().MappedContacts
                : [],
              MappedRoundTables: doc.data().MappedRoundTables
                ? doc.data().MappedRoundTables
                : [],
              contactcount: doc.data().MappedContacts.length,
              Files: doc.data().Resources,
              fileLength: doc.data().Resources.length,
              resourceLinkLength:
                doc.data().ResourcesLink != undefined
                  ? doc.data().ResourcesLink.length
                  : 0,
              ShowcaseVideoURL: doc.data().ShowcaseVideoURL,
            });

            this.ExhibitorFiles = [];
            for (let i = 0; i < this.ExhibitorData[0].Files.length; i++) {
              var arr = this.ExhibitorData[0].Files[i].split("%2F");
              var arr2 = arr[arr.length - 1]
                .replace(/%20/g, " ")
                .replace(/%26/g, "")
                .replace(".pdf", "")
                .replace(".xlsx", "")
                .replace(".pptx", "")
                .replace(".docx", "")
                .replace(".mp4", "")
                .split("?");

              this.ExhibitorFiles.push({
                Filename: arr2[0],
                Url: this.ExhibitorData[0].Files[i],
              });
            }
            this.ExhibitorLinks = doc.data().ResourcesLink;

            if (this.ExhibitorData[0].Website !== "") {
              if (this.ExhibitorData[0].Website.indexOf("http") < 0) {
                this.ExhibitorData[0].Website =
                  "http://" + this.ExhibitorData[0].Website;
              }
            }
            self.getUpdatedStatus();
            for (
              let i = 0;
              i < this.ExhibitorData[0].MappedContacts.length;
              i++
            ) {
              if (
                this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL !==
                undefined
              ) {
                if (
                  this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL ===
                  ""
                ) {
                  this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL =
                    "../images/avtaar.png";
                } else {
                  //this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL = this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL;
                }
              } else {
                this.ExhibitorData[0].MappedContacts[i].ProfilePictureURL =
                  "../images/avtaar.png";
              }
            }

            var i;
            for (
              i = 0;
              i < this.ExhibitorData[0].MappedRoundTables.length;
              i++
            ) {
              this.getRoundTable(
                this.ExhibitorData[0].MappedRoundTables[i].TableId
              );
            }

            if (this.ExhibitorData[0].MappedRoundTables.length == 0) {
              $("#dvMainRoundTable").hide();
              $("#round-table-tooltip").hide();
            } else {
              $("#dvMainRoundTable").show();
              $("#round-table-tooltip").show();
            }
          });
        });
    },
    ExchangeBusinessCard: function () {
      const obj = JSON.parse(window.localStorage["my-app"]);
      $("#btnBusinessCard").text("Exchanging Business Card");
      $("#btnBusinessCard").attr("disabled", true);
      self.closeDiv("dvexchangeCard");

      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };

      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          userId: obj.user[0].id,
          exhibitorId: obj.selExhibitorID,
          msg: $("#sendBunessCardMsg").val(),
        },
      };
      axios
        .post(self.APIs.Exchangebusinesscard, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          $("#exampleModalCenter").modal("hide");
          $("#sendBunessCardMsg").val("");
          document.getElementById("dvOtherMsg").innerText = self.$t(
            "expoview.bussinesscardexchangesuccess"
          );
          $("#Othermsg-modal").modal("show");

          // //"Business card Exchanged successfully";
          // $("#btnBusinessCard").text(self.$t("expoview.exchangecard"));
          // $("#btnBusinessCard").attr("disabled", false);

          console.log(response);
        })
        .catch((error) => {
          $("#exampleModalCenter").modal("hide");
          $("#sendBunessCardMsg").val("");
          document.getElementById("dvOtherMsg").innerText = self.$t(
            "expoview.bussinesscardexchangefail"
          );
          $("#Othermsg-modal").modal("show");
          console.log(error);
          // $("#btnBusinessCard").text(self.$t("expoview.exchangecard"));
          // $("#btnBusinessCard").attr("disabled", false);
          // self.closeDiv("dvexchangeCard");

          // //"Business card Exchanged Failed";
          // $("#Othermsg-modal").modal("show");
          return false;
        });
    },
    setFirebaseAppsettings: function () {
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");
      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    AddAnalitics: function (btnName, action) {
      //debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          //debugger;
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    closeDiv(val) {
      var src = $("#frmVideo").attr("src");
      $("#frmVideo").attr("src", "");
      $("#frmVideo").attr("src", src);

      // $(".youtube-video")[0].contentWindow.postMessage(
      //   '{"event":"command","func":"stopVideo","args":""}',
      //   "*"
      // );
      // $("#frmVideo.youtube-video")[0].contentWindow.postMessage(
      //   '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      //   "*"
      // );
      $("#" + val).hide();
    },
    showDiv(val) {
      $("#" + val).show();
    },
    LoadNext(id) {
      //this.loadscripts();
      self.exid = id;
      self.showVideoFlg = false;
      self.setFirebaseAppsettings();
      self.showLoader();
      if (self.exid !== undefined) {
        if (self.exid !== "") {
          store.commit("addExhibitorID", self.exid);
        } else {
          router.push({ name: "ExhibitorsHall" });
        }
      } else {
        router.push({ name: "ExhibitorsHall" });
      }
      this.ExhibitorData = [];
      this.ExhibitorFiles = [];
      this.HotspotSettings = [];
      this.ExhibitorLinks = [];
      this.getExhibitorDetails();
      self.hideLoader();
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      this.getPrv(id);
      this.getNxt(id);
      //router.push("/exhibitorsview/"+id);
    },
    getPrv(id) {
      var selID;
      var arr;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      arr = obj.exbList.split(",");

      this.ExhibitorFiles = [];
      this.ExhibitorData = [];
      this.ExhibitorLinks = [];
      if (id !== undefined) {
        if (id !== "") {
          store.commit("addExhibitorID", id);
          selID = id;
        } else {
          selID = obj.selExhibitorID;
        }
      } else {
        selID = obj.selExhibitorID;
      }

      console.log(arr);
      console.log("currindex " + arr.indexOf(selID));
      if (arr.indexOf(selID) > 0) {
        console.log("prv " + arr[arr.indexOf(selID) - 1]);
        this.prv = arr[arr.indexOf(selID) - 1];
        return arr[arr.indexOf(selID) - 1];
      } else {
        console.log("prv " + arr[arr.length - 1]);
        this.prv = arr[arr.length - 1];
        return arr[arr.length - 1];
      }
    },
    getNxt(id) {
      var selID;
      var arr;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      this.ExhibitorFiles = [];
      this.ExhibitorData = [];
      this.ExhibitorLinks = [];
      arr = obj.exbList.split(",");

      if (id !== undefined) {
        if (id !== "") {
          store.commit("addExhibitorID", id);
          selID = id;
        } else {
          selID = obj.selExhibitorID;
        }
      } else {
        selID = obj.selExhibitorID;
      }

      if (arr.indexOf(selID) < arr.length - 1) {
        console.log("nxt " + arr[arr.indexOf(selID) + 1]);
        this.nxt = arr[arr.indexOf(selID) + 1];
        return arr[arr.indexOf(selID) + 1];
      } else {
        console.log("nxt " + arr[0]);
        this.nxt = arr[0];
        return arr[0];
      }
    },
    getRoundTable(id) {
      //id = "729000";
      self.roundtableData = [];
      if (this.roundtableData.length == 0) {
        $("#dvMainRoundTable").hide();
        $("#round-table-tooltip").hide();
      } else {
        $("#dvMainRoundTable").show();
        $("#round-table-tooltip").show();
      }
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("RoundTableList")
        .collection("RoundTables")
        .where("TableId", "==", id)
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //--------------------------------
            var isMappedasAttendee = false;
            var isHost = false;
            var hostId = "0";
            var preassinedAtt = doc.data().MappedAttendees;
            var preAssisgnedAtt = preassinedAtt.filter(function (value) {
              return value.AttendeeId == self.userid;
            });
            if (preAssisgnedAtt.length > 0) {
              isMappedasAttendee = true;
            }
            var host = doc.data().Host;
            if (host != undefined) {
              if (host.length > 0) {
                hostId =
                  host[0].AttendeeId == undefined ? "0" : host[0].AttendeeId;
                if (
                  host[0].AttendeeId != undefined &&
                  host[0].AttendeeId == self.userid
                ) {
                  isHost = true;
                }
              }
            }

            var img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F01.jpg?alt=media";
            var tbObj = new Object();
            //tbObj.topicVisibility = false;

            //  self.tid = this.$route.params.tid == undefined ? "" : this.$route.params.tid;
            // if (self.tid == "" || self.tid.toLowerCase() == "all") {
            //   tbObj.topicVisibility = true;
            // } else {
            //   if (doc.data().Topic.TopicId == self.tid) {
            //     tbObj.topicVisibility = true;
            //   }
            // }

            tbObj.topicVisibility = true;
            //---------------id and capacity array------------------------------------------
            var tbObjIds = new Object();
            tbObjIds.id = doc.id;

            // if (doc.id == "961000") {
            //   //debugger;
            // }
            tbObjIds.Capacity = isNaN(doc.data().Capacity)
              ? 12
              : doc.data().Capacity;

            //self.roundtableIds.push(doc.id);
            self.roundtableIds.push(tbObjIds);
            //-----------------------------------------------------------

            tbObj.id = doc.id;
            tbObj.hostId = hostId;
            console.log(doc.id + "HostId:- " + hostId);
            tbObj.Name = doc.data().TableName;
            tbObj.Occupied = doc.data().Occupied;
            tbObj.Capacity = doc.data().Capacity;
            tbObj.BroadcastID = self.GlobalKeysData.BroadcastID;
            tbObj.BroadcastCertificat =
              self.GlobalKeysData.BroadcastCertificate;
            tbObj.BroadcastSpeakerApiUrl =
              self.GlobalKeysData.BroadcastSpeakerApiUrl;
            tbObj.BroadcastAttendeeApiUrl =
              self.GlobalKeysData.BroadcastAttendeeApiUrl;
            tbObj.BroadcastStartURL = self.GlobalKeysData.BroadcastStartURL;
            tbObj.BroadcastViewURL = self.GlobalKeysData.BroadcastViewURL;
            tbObj.BroadcastvalidityHours =
              self.GlobalKeysData.BroadcastvalidityHours;
            tbObj.ChannelPrefix = self.GlobalKeysData.ChannelPrefix;
            tbObj.IsHost = isHost;
            tbObj.IsMappedasAttendee = isMappedasAttendee;
            tbObj.PreAssigned = doc.data().PreAssigned;
            tbObj.SpectatorEnabled = doc.data().SpectatorEnabled;
            tbObj.IsTblVisible = false;
            tbObj.IsVisible = false;
            tbObj.IsTableFull = false;
            tbObj.imgsrc = img;
            tbObj.StreamingClient = "";
            tbObj.StreamingClientLink = "";
            if (
              doc.data().StreamingClient &&
              doc.data().StreamingClient.trim() != ""
            ) {
              tbObj.StreamingClient = doc.data().StreamingClient.trim();
            }
            if (
              doc.data().StreamingClientLink &&
              doc.data().StreamingClientLink.trim() != ""
            ) {
              tbObj.StreamingClientLink = doc.data().StreamingClientLink.trim();
            }
            if (tbObj.StreamingClient.toLowerCase() == "zoom") {
              tbObj.Capacity = 16;
              tbObj.Zoom_Detail = doc.data().Zoom_Detail;
            }

            self.roundtableData.push(tbObj);
          });
          self.getTblTest();
        }) //querySnapshot.forEach(doc =>  ENDING PART
        .catch((error) => {
          console.log(error);
        });
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    JoinTable: function (
      hostId,
      videoParamsEncryptURL,
      IsBroadcastInNewTab,
      tableId,
      tableName,
      leaveTable,
      ChannelPrefix,
      BroadcastID,
      BroadcastCertificate,
      BroadcastSpeakerApiUrl,
      BroadcastAttendeeApiUrl,
      BroadcastvalidityHours,
      UserID,
      eventID,
      BroadcastStartURL,
      BroadcastViewURL,
      IsHost,
      IsMappedasAttendee,
      PreAssigned,
      SpectatorEnabled,
      Capacity,
      Occupied,
      IsVisible,
      IsTableFull,
      IsOpenInternalPlayer,
      StreamingClient,
      Zoom_Detail
    ) {
      if (IsVisible && !IsTableFull) {
        if (IsOpenInternalPlayer == 1) {
          self.GoForInternalPlayerRT(
            tableId,
            StreamingClient,
            Zoom_Detail,
            hostId
          );
        } else {
          var OnAirVCount = this.readCookieForVideo("onairvcount");
          var videoLaunchFlag = true;
          if (OnAirVCount != null) {
            if (parseInt(OnAirVCount) >= 1) {
              if (
                !confirm(
                  "An active OnAir video seems to be running, it is recommended to open one video at a time for best performance. Do you still want to open the video in another tab?"
                )
              ) {
                videoLaunchFlag = false;
              }
            }
          }
          if (videoLaunchFlag) {
            //alert(videoParamsEncryptURL);
            if (tableId == undefined || tableId == "" || tableId == 0) {
              //  alert("Invalid table selected");
              return;
            }
            //
            var obj = JSON.parse(window.localStorage.getItem("my-app"));
            var clntid = obj.client[0].id;
            // self.clientid = obj.user[0].id;
            var evntid = obj.eventid;
            var usrid = obj.user[0].id;
            self.eventcollectionname = obj.eventcollectionname;

            console.log("JoinTable- usrid : -" + usrid);
            console.log(Occupied);

            var OpenBroadcastWindow = 0;
            // var isSpectate = 1; //audience mode
            var openAsSpeaker = false;
            var openAsAudience = false;
            var participantOccupied = 0;

            db.collection(self.eventcollectionname)
              .doc("RoundTableList")
              .collection("RoundTables")
              .doc(tableId)
              .collection("Participances")
              //.where("IsActive", "==", true)
              .get()
              .then((querySnapshot) => {
                //
                var filteredIds = querySnapshot.docs.filter(function (value) {
                  return (
                    value.data().AttendeeId != hostId &&
                    value.data().IsActive == true
                  );
                });

                participantOccupied = filteredIds.length + 1;

                if (IsHost) {
                  openAsSpeaker = true;
                } else if (PreAssigned) {
                  if (IsMappedasAttendee) {
                    openAsSpeaker = true;
                  } else if (SpectatorEnabled) {
                    openAsAudience = true;
                  }
                } else if (participantOccupied < Capacity) {
                  openAsSpeaker = true;
                } else if (SpectatorEnabled) {
                  openAsAudience = true;
                }

                OpenBroadcastWindow = 1;

                if (OpenBroadcastWindow == 1) {
                  var channelid2 =
                    ChannelPrefix +
                    "_" +
                    evntid.substring("1") +
                    "_" +
                    tableId.toString().toLowerCase().replace("rt", "") +
                    "_rt";
                  // alert(channelid2);
                  console.log(channelid2);

                  // alert(videoURL);
                  var broadcastTypeUrl = "";

                  if (openAsAudience == true) {
                    broadcastTypeUrl = BroadcastViewURL;
                  }
                  if (openAsSpeaker == true) {
                    broadcastTypeUrl = BroadcastStartURL;
                  }
                  console.log(
                    "Parameters - url - " +
                      videoParamsEncryptURL +
                      "broadcastTypeUrl- " +
                      broadcastTypeUrl +
                      "BroadcastvalidityHours - " +
                      BroadcastvalidityHours +
                      "channelid2 - " +
                      channelid2 +
                      "usrid - " +
                      usrid +
                      "tableName - " +
                      tableName +
                      " clntid - " +
                      clntid
                  );

                  this.getEncryptedVideoURLParams(
                    videoParamsEncryptURL,
                    broadcastTypeUrl,
                    BroadcastvalidityHours,
                    channelid2,
                    usrid,
                    tableName,
                    clntid,
                    function (videoURL, usrid) {
                      // alert(videoURL);
                      console.log(usrid);

                      if (IsBroadcastInNewTab) {
                        //window.parent.location.reload();
                        window.open(videoURL, "_blank");
                      } else {
                        $("#iframeBroadcast").attr(
                          "src",
                          videoURL + "&t=" + new Date().getTime()
                        );
                        $("#modalOpenBroadcast").modal();
                      }
                    }
                  );
                } else {
                  //alert("You are not allowed to join this table");
                }
              });
          }
        }
      }
    },
    callAjaxService: function (
      serviceUrl,
      requestData,
      cacheName,
      refreshCache,
      callBackFunction
    ) {
      //alert(JSON.stringify(requestData));
      var e2mToken =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySUQiOiIxNDQzMDUiLCJzeXN0ZW1UeXBlIjoiNiIsIm5iZiI6MTU5MTY0ODU4NywiZXhwIjoxNTkxNjUwMzg3LCJpYXQiOjE1OTE2NDg1ODcsImlzcyI6InNlbGYiLCJhdWQiOiIqIn0.aTEXVwBOM2AU3oHHyWTzJ6EP4UmsHiBc7Wrqpv9xNEY"; // JSON.parse(sessionStorage.getItem('e2mt'));
      var settings = {
        url:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/" +
          serviceUrl,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          Authorization: "2c560485-d443-46e5-9f50-7a5535b24931",
          OS: "WEB",
          eToken: e2mToken,
        },
        data: JSON.stringify(requestData),
      };

      $.ajaxSetup({
        url: serviceUrl,
        beforeSend: function () {},
        complete: function () {
          //alert('4');
        },
      });
      $.ajax(settings)
        .done(function (response) {
          //alert(JSON.stringify(response));
          callBackFunction(response);
        })
        .fail(function (xhr) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          console.log(errorMessage);
        });
    },
    getTblTest: function () {
      console.log(self.roundtableIds.length);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      for (var j = 0; j < self.roundtableIds.length; j++) {
        /* var col_name =
          "/" +
          obj.eventcollectionname +
          "/RoundTableList/RoundTables/" +
          self.roundtableIds[j] +
          "/Participances";
       */
        var col_name =
          "/" +
          obj.eventcollectionname +
          "/RoundTableList/RoundTables/" +
          self.roundtableIds[j].id +
          "/Participances";
        db.collection(col_name)
          // .where("IsActive", "==", true)
          .onSnapshot((querySnapshot) => {
            // console.log("listner callded");
            //debugger;
            //if (querySnapshot.docs.length > 0) {
            //  var ftid = querySnapshot.docs[0].data().TableId;
            //  var tblList = self.roundtableIds.filter(function (item) {
            //    // alert(item.id);
            //    // alert(ftid);
            //    return item.id == ftid;
            //  });
            //  //debugger;
            //  if (tblList.length > 0) {
            //    capa = tblList[0].Capacity;
            //  }
            //}
            var members = [];
            var curtbId;
            let iAmInTheTable = false;
            querySnapshot.forEach((doc) => {
              var participant = doc.data();
              // console.log(curDoc);
              curtbId = participant.TableId;
              let attType = 1;
              if (
                participant.AttendeeType != undefined &&
                participant.AttendeeType != null
              ) {
                attType = participant.AttendeeType;
              }
              if (participant.IsActive && attType > 0 && attType < 4) {
                if (participant.AttendeeId == self.userid) {
                  iAmInTheTable = true;
                }
                members.push(participant);
              }
              //if (participant.IsActive) {
              //  members.push(participant);
              //}
            });
            //alert("capa " + capa);
            self.updateSinglTable(curtbId, members, iAmInTheTable);
            //console.log(members);
          });
      }
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
    },
    toggleModal: function () {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    getEncryptedVideoURLParams: function (
      videoParamsEncryptURL,
      VideoBaseURL,
      TokenValidityHours,
      ChannelID,
      UserID,
      SessionTitle,
      clientId,
      callBackFunction
    ) {
      // alert("getEncryptedVideoURLParams");
      console.log(
        "qString - channelName - " +
          ChannelID.toString() +
          " userId- " +
          parseInt(UserID) +
          " validityHours - " +
          parseInt(TokenValidityHours) +
          " isScreen - 0" +
          " sname - " +
          SessionTitle.toString() +
          " clientID - " +
          clientId
      );

      var qString = {
        channelName: ChannelID.toString(),
        userId: parseInt(UserID),
        validityHours: parseInt(TokenValidityHours),
        isScreen: 0,
        sname: SessionTitle.toString(),
        clientId: clientId,
      };
      var encParam = "";
      var videoURL = VideoBaseURL;

      $.ajax({
        url: videoParamsEncryptURL,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {
          //self.showLoader();
        },
        type: "POST",
        dataType: "json",
        data: JSON.stringify(qString),
        success: function (data) {
          //self.hideLoader();
          if (typeof data != "undefined") {
            let lStatusCode = 0;
            lStatusCode = data.status;
            if (lStatusCode == 0) {
              encParam = data.result;
              videoURL = videoURL + "?vt=" + encParam;
              callBackFunction(videoURL, UserID);
              console.log("Get Encrypt URL API Call Success");
            } else {
              //self.hideLoader();
              alert("Error in opening roundtable. Please retry. ");
              // console.log("Encrypted URL not found in API Call");
              //alert("URL decode has been failed before starting OnAir");
            }
          } else {
            //self.hideLoader();
            alert("Error in opening roundtable. Please retry. ");
            //console.log("Encrypted URL not found in API Call");
            //alert("URL decode has been failed before starting OnAir");
          }
        },
        error: function () {
          //self.hideLoader();
          alert("Error in opening roundtable. Please retry. ");
          //console.log("Error in Get Encrypt URL API Call");
          //alert("URL decode has been failed before starting OnAir");
        },
      });
    },
    updateSinglTable: function (curtbId, members, iAmInTheTable) {
      // var cnt = members.length;
      //console.log(cnt);
      var img = "";
      for (var i = 0; i < self.roundtableData.length; i++) {
        if (self.roundtableData[i].id == curtbId) {
          let table = self.roundtableData[i];
          var Capacity = table.Capacity;
          var filteredIds = members.filter(function (value) {
            return value.AttendeeId != table.hostId && value.IsActive == true;
          });
          var cnt = filteredIds.length + 1;

          /*============================================================================================================================================== */
          if (cnt < 1) {
            cnt = 1;
          } else if (cnt > Capacity) {
            cnt = Capacity;
          }
          //==================================================
          //  alert("Capacity " + Capacity);
          if (filteredIds.length == members.length) {
            //host inactive
            if (cnt == undefined || cnt <= 0) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 1) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 2) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 3) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 4) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 5) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 6) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 7) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 8) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 9) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 10) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 11) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F11.jpg?alt=media&token=802d8c4a-0c26-4493-a111-dc95d659b6a5";
            } else if (cnt == 12) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F12.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 13) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F13.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 14) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F14.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 15) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F15.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt >= 16) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F16.jpg?alt=media";
            }
          } else {
            //host active
            if (cnt == undefined || cnt <= 0) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 1) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 2) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 3) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 4) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 5) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 6) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 7) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 8) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 9) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 10) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 11) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F11.jpg?alt=media&token=1d49ccca-4d81-4d53-bf95-b635598bc0a8";
            } else if (cnt == 12) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F12.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 13) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F13.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 14) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F14.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 15) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F15.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt >= 16) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F16.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            }
          }

          var tableLabel = "GRAB A SEAT";
          var LabelCss = "grab-a-seat";
          var showTable = false;
          var tableFull = false;
          //alert(table.IsHost);
          if (table.IsHost) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.PreAssigned) {
            if (table.IsMappedasAttendee) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Speaker

              showTable = true;
            } else if (table.SpectatorEnabled) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Audience
              showTable = true;
              tableLabel = "SPECTATE";
              LabelCss = "spectate";
            }
          } else if (iAmInTheTable) {
            showTable = true;
          } else if (cnt < table.Capacity) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.SpectatorEnabled) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Audience
            showTable = true;
            tableLabel = "SPECTATE";
            LabelCss = "spectate";
          } else {
            showTable = true;
            tableFull = true;
            tableLabel = "TABLE FULL";
            LabelCss = "table-full";
          }
          //alert(tableLabel);
          /*========================================================================================================== */
          table.IsTblVisible = showTable && table.topicVisibility;
          table.IsVisible = showTable;
          table.IsTableFull = tableFull;
          table.tableLabel = tableLabel;
          table.imgsrc = img;
          table.LabelCss = LabelCss;
          console.log(img);
          break;
        }
      }
    },
    getParticipance: function (table) {
      //var arrparticipance = [];
      table.participantList = [];
      db.collection(self.eventcollectionname)
        .doc("RoundTableList")
        .collection("RoundTables")
        .doc(table.id)
        .collection("Participances")
        //.where("IsActive", "==", true)
        .get()
        .then((querySnapshot) => {
          //
          var filteredIds = querySnapshot.docs.filter(function (value) {
            return (
              value.data().AttendeeId != table.hostId &&
              value.data().IsActive == true
            );
          });
          //alert(table.Name + " - " + filteredIds.length);
          var cnt = filteredIds.length + 1;
          /*=================================================================================== */

          /*======================================================================================== */
          var img = "";
          if (cnt == undefined || cnt == 0) {
            img = "https://e2monairuat.e2m.live/Images/06.png";
          } else if (cnt == 1) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F01.jpg?alt=media";
          } else if (cnt == 2) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F02.jpg?alt=media";
          } else if (cnt == 3) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F03.jpg?alt=media";
          } else if (cnt == 4) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F04.jpg?alt=media";
          } else if (cnt == 5) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F05.jpg?alt=media";
          } else if (cnt == 6) {
            img =
              "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FRound%20Tables%2F06.jpg?alt=media";
          }
          table.imgsrc = img;

          /*====================================================================================================== */

          var tableLabel = "GRAB A SEAT";
          var showTable = false;
          if (table.PreAssigned) {
            if (table.IsMappedasAttendee) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Speaker

              showTable = true;
            } else if (table.SpectatorEnabled) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Audience
              showTable = true;
              tableLabel = "SPECTATE";
            }
          } else if (cnt < table.Capacity) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.SpectatorEnabled) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Audience
            showTable = true;
            tableLabel = "SPECTATE";
          } else {
            tableLabel = "TABLE FULL";
          }
          table.tableLabel = tableLabel;
          /*========================================================================================================== */
          if (showTable) {
            self.roundtableData.push(table);
          }
        });
    },
    getSettings: function () {
      this.selectExpoMenu();

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // this.ExhibitorSettings.push(
            //   {
            //     AllowAttendeeMeetingWithExhibitors : doc.data().AllowAttendeeMeetingWithExhibitors,
            //     DisplayExhibitorContactsOnBooths:doc.data().DisplayExhibitorContactsOnBooths,
            //     DisplayRoundtablesforExpoBooths:doc.data().DisplayRoundtablesforExpoBooths,
            //     EnableChatOrEmailwithExhibitor:doc.data().EnableChatOrEmailwithExhibitor,
            //     EnableEnhancedExpoMode : doc.data().EnableEnhancedExpoMode,
            //     EnableExhibitorFilterAndSearchOption:doc.data().EnableExhibitorFilterAndSearchOption,
            //     EnableExhibitorShowcaseVideo:doc.data().EnableExhibitorShowcaseVideo,
            //     IsEnhancedHotspotting:doc.data().IsEnhancedHotspotting,
            //     ShowExhibitorCollateralsForDownload:doc.data().ShowExhibitorCollateralsForDownload
            //   }
            // )

            //---------For innitial page load get the settings for VIDEO----------
            //
            self.EnableExhibitorRepVideoCall =
              doc.data().EnableExhibitorRepVideoCall;
            self.AllowMoreThan1tojoinRepInVideoCall =
              doc.data().AllowMoreThan1tojoinRepInVideoCall;
            self.ShowRepActiveStatus = doc.data().ShowRepActiveStatus;
            // if (doc.data().JoinTheConversationText) {
            //   self.JoinTheConversationText = doc.data().JoinTheConversationText;
            // } else {
            //   self.JoinTheConversationText =
            //     "Welcome to {BoothName} Our Reps are here to assist you. You can also contact us on {phone} or visit {BoothWebsite}";
            // }
            // Welcome to {{ item.Name }}! Our Reps are here to assist
            //                         you. You can also contact us on
            //                         <a :href="'tel:' + item.Phone">{{ item.Phone }}</a> or
            //                         visit
            //                         <a :href="item.Website">{{ item.Website }}</a>
            // self.JoinTheConversationText = self.JoinTheConversationText.replace(
            //   "{BoothName}",
            //   self.ExhibitorData[0].Name
            // )
            //   .replace(
            //     "{phone}",
            //     '<a :href="tel:' +
            //       self.ExhibitorData[0].Phone +
            //       '">' +
            //       self.ExhibitorData[0].Phone +
            //       "</a>"
            //   )
            //   .replace(
            //     "{BoothWebsite}",
            //     '<a target="_blank" href="' +
            //       self.ExhibitorData[0].Website +
            //       '">' +
            //       self.ExhibitorData[0].Website +
            //       "</a>"
            //   );

            // alert(
            //   "self.EnableExhibitorRepVideoCall - " +
            //     self.EnableExhibitorRepVideoCall
            // );
            // if (self.AllowMoreThan1tojoinRepInVideoCall) {
            //   self.VideoCallEnable = true;
            // } else {
            //   self.VideoCallEnable = false;
            // }
            //--------------------------------------------------------------------

            if (doc.data().ExpoHallBackgroundImage !== undefined) {
              if (doc.data().ExpoHallBackgroundImage !== "") {
                self.ExpoHallBackgroundImage =
                  doc.data().ExpoHallBackgroundImage;
              } else {
                self.ExpoHallBackgroundImage =
                  "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
              }
            } else {
              self.ExpoHallBackgroundImage =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
            }
            //alert(self.ExpoHallBackgroundImage);
            if (doc.data().AllowBusinessCardExchange == false) {
              $(".exchange-businesscard-lite").hide();
              self.showBusinessCardBtn = false;
            } else {
              $(".exchange-businesscard-lite").show();
              self.showBusinessCardBtn = true;
            }

            if (doc.data().EnableExhibitorShowcaseVideo == false) {
              $("a[title$='Video']").hide();
            } else {
              $("a[title$='Video']").show();
            }

            if (doc.data().DisplayExhibitorContactsOnBooths == false) {
              $("a[title$='Start Conversation']").hide();
            } else {
              $("a[title$='Start Conversation']").show();
            }

            if (doc.data().ShowExhibitorCollateralsForDownload == false) {
              $("a[title$='Collateral']").hide();
            } else {
              $("a[title$='Collateral']").show();
            }

            if (doc.data().EnableChatOrEmailwithExhibitor == false) {
              $(".openBroadcast").hide();
            } else {
              $(".openBroadcast").show();
            }

            if (doc.data().AllowAttendeeMeetingWithExhibitors == false) {
              $(".reqMeeting").hide();
            } else {
              $(".reqMeeting").show();
            }
            if (doc.data().AllowAttendeeChatWithExhibitors == false) {
              $(".reqChat").hide();
            } else {
              $(".reqChat").show();
            }

            if (doc.data().DisplayRoundtablesforExpoBooths == false) {
              if (document.getElementById("dvMainRoundTable").parentElement) {
                document.getElementById("dvMainRoundTable").style.visibility =
                  "hidden";
                $("#round-table-tooltip").hide();
              }
            } else {
              if (document.getElementById("dvMainRoundTable").parentElement) {
                document.getElementById("dvMainRoundTable").style.visibility =
                  "visible";
                $("#round-table-tooltip").show();
              }
            }

            if (this.ExhibitorData[0].ShowcaseVideoURL === "") {
              $("a[title$='Video']").hide();
            }

            if (this.ExhibitorData[0].contactcount === 0) {
              $("a[title$='Start Conversation']").hide();
            }

            if (
              this.ExhibitorData[0].fileLength === 0 &&
              this.ExhibitorData[0].resourceLinkLength === 0
            ) {
              $("a[title$='Collateral']").hide();
            }
            self.showAerialView = doc.data().AllowAerialView;
            if (doc.data().AllowbirdView) {
              //alert(doc.data().AllowbirdView)
              self.showBirdView = doc.data().AllowbirdView;
            } else {
              self.showBirdView = false;
            }
          });
          self.getUpdatedStatus();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // clearRefresh: function () {
    //   clearInterval(interval);
    //   this.removeSelection();
    // },
    selectExpoMenu: function () {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      //$("#liexhibitor").first().addClass("active");
    },
    removeSelection: function () {
      $("#liexhibitor")
        .find("a:first")
        .removeClass("router-link-exact-active router-link-active");
    },
    OpenOneToOneChat(data) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var sequences;
      var loggedInUserId = obj.user[0].id;
      var partnerId = data.AttendeeId;
      self.showLoader();
      if (parseInt(partnerId) > parseInt(loggedInUserId)) {
        sequences = loggedInUserId + "-" + partnerId;
      } else {
        sequences = partnerId + "-" + loggedInUserId;
      }
      db.collection(obj.eventcollectionname)
        .doc("ChatList")
        .collection("Chats")
        .doc(sequences)
        .collection("Messages")
        .get()
        .then((doc) => {
          if (doc.size > 0) {
            bus.$emit("enterIndividualChat", data);
            self.hideLoader();
          } else {
            var requestData = {};
            requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: obj.client[0].id,
                eventId: obj.eventid,
              },

              data: {
                partnerId: data.AttendeeId,
                message: self.defaultChatMsg,
              },
            };
            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            axios
              .post(
                self.APIs.ChatAPIConfig.SendMessage,
                JSON.stringify(requestData),
                {
                  headers: headers,
                }
              )
              .then((response) => {
                console.log("response==", response);
                self.hideLoader();
                self.openListPopup();
              })
              .catch((error) => {
                self.hideLoader();
                console.log(error);
              });
          }
        });

      //debugger;
    },
    checkSettingFlagValue() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("EventInfo")
        .get()
        .then((doc) => {
          if (doc.exists) {
            var docs = doc.data();
            if (docs.Plugins.OneToOneChat != undefined) {
              this.defaultChatMsg = docs.Plugins.OneToOneChat.defaultChatMsg;
            }
          }
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
        });
    },
    openListPopup() {
      var x = document.getElementById("float-chat-pannel");
      if (x.style.display === "none") {
        x.style.display = "block";
        bus.$emit("toggleChatIcon", true);
      }
    },
    playVideoURL() {
      this.showVideoFlg = true;
    },
  },
  mounted() {
    self = this;
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj != undefined && obj != null) {
      if (obj.user != undefined && obj.user.length > 0) {
        self.userid = obj.user[0].id;
      }
    }
    self.checkSettingFlagValue();
    // $("#btnAddUserView").click();

    $("#topmenu").show();
    // $("#leftmenu").show();
    self.getSettings();
    // if ($("#ulLeftMenu li").length > 0) {
    //   $("#leftMenuParent").show();
    //   $("#leftmenu").show();
    // } else {
    //   $("#leftMenuParent").hide();
    //   $("#leftmenu").hide();
    // }

    //var obj = JSON.parse(window.localStorage.getItem("my-app"));

    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              //self.headerText = value.DisplayLabel;
              var headText = "";
              if (self.$store.state.locale == "English") {
                headText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                headText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                headText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                headText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                headText = value.DisplayLabel_es;
              } else {
                headText = value.DisplayLabel;
              }
              $("#boothHeaderTxt").text(headText);
            }
          }
        });
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              //self.headerText = value.DisplayLabel;
              var headText = "";
              if (self.$store.state.locale == "English") {
                headText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                headText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                headText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                headText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                headText = value.DisplayLabel_es;
              } else {
                headText = value.DisplayLabel;
              }
              $("#boothHeaderTxt").text(headText);
            }
          }
        });
      });

    document.title = self.headerText + " - " + obj.eventname;

    //var newLine = "\r\n";
    //var newLine = "";
    var defaultMsg = self.$t("expoview.exchangetxtmsg");
    // "Hello," +
    // newLine +
    // newLine +
    //"I dropped by your booth, please contact me.";
    // newLine +
    // newLine +
    // "Thanks";

    $("#sendBunessCardMsg").val(defaultMsg);

    //var obj = JSON.parse(window.localStorage.getItem("my-app"));

    //-------Page Title-------------
    //-------Page Title-------------

    //---------------------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------

    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    self.exid = obj.selExhibitorID;
    console.log("currentExhiid" + self.exid);
    self.setFirebaseAppsettings();
    self.showLoader();
    // if (obj.selExhibitorID !== undefined) {
    //   if (obj.selExhibitorID !== "") {
    //     store.commit("addExhibitorID", self.exid);
    //   } else {
    //     router.push({ name: "ExhibitorsHall" });
    //   }
    // } else {
    //   router.push({ name: "ExhibitorsHall" });
    // }
    this.ExhibitorData = [];
    this.HotspotSettings = [];
    this.ExhibitorSettings = [];

    this.getExhibitorDetails();
    self.hideLoader();
    this.getPrv(self.exid);
    this.getNxt(self.exid);
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);

    //this.loadscripts();

    interval = setInterval(() => {
      self.getSettings();
    }, 1000);

    // clearInterval(interval);
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 1000);
    setTimeout(() => {
      $('[data-toggle="tooltip1"]').tooltip();
    }, 1000);
    setTimeout(() => {
      $('[data-toggle="tooltip2"]').tooltip();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(interval);
    this.removeSelection();
  },
};
</script>